var utils = require('./extrax2-webadmin.utils.js');
var ajax = require('./extrax2-webadmin.ajax.js');
var changes = require('./extrax2-webadmin.changes.js');
var initialize = require('./extrax2-webadmin.initialize.js');
var validator = require('./extrax2-webadmin.validator.js');

function registerCommonEvents() {

	utils.resizeBackgroundImage();
	utils.handleContentHeight();

	window.onload = window.onbeforeload = (
		function (e) {
			if (/cbp=/.test(window.location.href)) {
				window.location.href = window.location.href.substr(0, window.location.href.lastIndexOf('#'));
			}
		});

	// maximale Höhe des Details Tab neu berechnen
	$(window).resize(function () {
		utils.setPortletMaxHeight();
		utils.setDetailPortletMaxHeight();
		utils.resizeBackgroundImage();
	});

	// Auf Änderungen prüfen und ggf. speichern (click)
	document.body.addEventListener('click', changes.saveChanges, true);

	// Input / DatePanel - Auswahl 'Unbegrenzt'
	$('body').on('click', '.tt-select-unlimited', function (e) {
		e.preventDefault();

		if ($(this).parent().hasClass('active')) {
			return;
		}

		utils.setInputUnlimitedValue(this);

		$(this).parents('form').addClass('dirty');
	});

	// DatePanel - Auswahl Datum 'dd.mm.yyyy' oder 'mm.yyyy' oder 'yyyy'
	$('body').on('click', '.tt-select-date-full, .tt-select-date-month-year, .tt-select-date-year', function (e) {
		e.preventDefault();

		if ($(this).parent().hasClass('active')) {
			return;
		}

		utils.setDatePickerDropDownValue(this, true);

		$(this).parents('form').addClass('dirty');
	});

	// Select2 Anzeige ändern, falls Wert ausgewählt ist
	$('body').on('change', '.tt-select2', function (e) {
		e.preventDefault();

		if ($(this).val()) {
			$(this).parents('.form-md-select2').addClass('edited');
		} else {
			$(this).parents('.form-md-select2').removeClass('edited');
		}
	});

	// DatePanels - Validierung und Datum richtig setzen
	$('body').on('change', '.timepicker', function (e) {

		$(this).val(utils.complementTimeString($(this).val()));
	});

	// DatePanels - Validierung und Datum richtig setzen
	$('body').on('blur', '.datepicker', function (e) {

		utils.blurDatepicker(this);
		if ($(this).parents('form').length) {
			$(this).parents('form').validate().element($(this));
		}

		if ($(this).hasClass('tt-search-date')) {
			if ($(this).parents('.tt-content-datatable').find('.tt-datatable-data').length) {
				if ($(this).parents('.tt-content-datatable').find('.tt-datatable-data')[0].id === 'table_account_draw_up') {
					initialize.loadAccountingList();
				}
			} else {
				if ($(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail')[0].id === 'table_request_history') {
					var fromVal = jQuery($('#from_date')).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '');
					var tillVal = jQuery($('#till_date')).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '');
					if (fromVal !== '' && tillVal !== '') {
						$(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail').DataTable().search('', true, true).draw();
					}
				} else {
					$(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail').DataTable().search($(this).parents('.tt-content-datatable').find('.tt-datatable-search').val().replace(/"/g, '\\b'), true, true).draw();
				}
			}
		}
	});

	$('body').on('keypress', '.datepicker', function (e) {
		if (e.keyCode == 13) {
			e.preventDefault();

			$(this).emulateTab();
		}
	});

	// 'Alle' bei Mehrfachauswahlen beachten; Validate Event auslösen
	$('body').on('select2:select', '.tt-select2[multiple]', function (e) {
		e.preventDefault();

		if (!utils.GLOBALS.programmaticChange) {
			utils.updateGlobals('programmaticChange', true);
			var element = $(this);

			if (!utils.isUndefined(e.params.data) && !utils.isUndefined($(e.params.data.element).data()) && ($(e.params.data.element).data().match === 'all')) {
				$(this).select2().val([e.params.data.id]).trigger('change');
			} else {
				var select_array = [];
				jQuery.each($(this).select2('data'), function (i, val) {
					if ($(val.element).data().match !== 'all') {
						select_array.push(val.id);
					}
				});
				$(this).select2().val(select_array).trigger('change');
			}
			$(this).parents('form').validate().element($(this));
		}

		utils.updateGlobals('programmaticChange', false);
	});

	// Select2 öffnen, wenn Focus gesetzt
	$('body').on('focusin', '.tt-select2:not([multiple]) .select2', function (e) {
		e.preventDefault();

		if (!$(this).isDisabled) {
			$(this).parent().find('select.tt-select2').select2('open');
		}
	});

	// Beträge im richtigen Format anzeigen
	$('body').on('focusout', '.tt-currency', function (e) {
		e.preventDefault();

		if ($(this).val().length) {
			try {
				$(this).val(utils.numberToString(utils.stringToNumber($(this).val()), 2));
			} catch (NaNError) {
			}
		}
	});

	// Navigation
	$(document).on('click', '.hor-menu .nav a[href!="#"]', function (e) {
		if ($(this).hasClass('disabled')) {
			return false;
		}

		e.preventDefault();

		var element = this;
		var url = $(e.currentTarget).attr('href');
		$(element).parents('nav').find('a').addClass('disabled');
		if (utils.isUndefined($(element).data('projectName'))) {
			$('#project_menu_item').text(' ' + trans('extrax2-webadmin.project'));
			$('#sub_menu_item').parent().addClass('hide');
			$('#sub_menu_item').text('');
			$('#sub_menu_item').parent().find('.dropdown-menu').remove();
			$('#selected_menu_item').parent().addClass('hide');
			$('#selected_menu_item').text('');
			$('#selected_menu_item').parent().find('.dropdown-menu').remove();
		} else {
			$('#project_menu_item').text(' ' + $(element).data('projectName'));
			$('#sub_menu_item').text(' ' + $(element).data('subMenuName'));
			$('#sub_menu_item').parent().removeClass('hide');
			$('#sub_menu_item').prepend('<i class="fa fa-lg fa-angle-right"></i>');
			$('#selected_menu_item').text(' ' + $(this).text());
			$('#selected_menu_item').parent().removeClass('hide');
			$('#selected_menu_item').prepend('<i class="fa fa-lg fa-angle-right"></i>');

			if ($(this).parents('.menu-dropdown-project').length) {
				$('#sub_menu_item').parent().find('.dropdown-menu').remove();
				$($(this).parents('.dropdown-menu')[1]).clone().appendTo($('#sub_menu_item').parent());
			}
			if ($(this).parents('.menu-dropdown-project').length || $(this).parents('.menu-dropdown-sub').length) {
				$('#selected_menu_item').parent().find('.dropdown-menu').remove();
				$($(this).parents('.dropdown-menu')[0]).clone().appendTo($('#selected_menu_item').parent());
			}
		}
		$('#project_menu_item').prepend('<i class="icon-puzzle"></i>');
		$('#project_menu_item').append('<span class="arrow"></span>');

		ajax.ajaxCall(url, 'GET', null, true, function (data) {
			utils.setHtmlData($("#content"), data, true);

			$(element).parents('nav').find('a').removeClass('disabled');
		});
	});

	// Dokument auswählen (Open-Folder-Dialog anzeigen)
	$('body').on('click', '.tt-select-file', function (e) {
		e.preventDefault();

		$('#file_upload')[0].click();
	});

	// Dialog angezeigt - Fokus auf erstes Input Feld setzen
	$('body').on('shown.bs.modal', '.tt-content-dialog', function (e) {

		$(this).find('.tt-save,.tt-save-sub-form').removeClass('disabled');
		if ($(this).find('input:enabled:not([type="hidden"]),.select2').length) {
			$(this).find('input:enabled:not([type="hidden"]),.select2')[0].focus();
		}
	});

	// Dialog schließen
	$('body').on('hide.bs.modal', '.tt-content-dialog', function (e) {
		if (!utils.isUndefined($(this).find('form')[0])) {

			// Form zurücksetzen
			utils.resetForm(this);
		}
	});

	// Submit aufrufen für Buttons welche im Portlet-Title sind
	$('body').on('click', '.tt-save', function (e) {
		e.preventDefault();

		if (!utils.isUndefined($(this).parents('.portlet').find('.portlet-body form')[0])) {

			var form = $(this).parents('.portlet').find('.portlet-body form')[0];

			if (form.id === "table_software_versions_detail_form" && !$(form).find('[name="is_beta_version"]')[0].checked && $(form).find('[name="is_beta_version"]').data().initValue && $(form).find('[name="is_productive_version"]')[0].checked && $('#send_update_info').val() === '0') {
				bootbox.dialog({
					message: Lang.get('extrax2-webadmin.message_update_info'),
					title: Lang.get('extrax2-webadmin.send_update_info'),
					buttons: {
						yes: {
							label: Lang.get('extrax2-webadmin.yes'),
							className: "btn btn-success bootbox-btn",
							callback: function () {
								$('#send_update_info').val('1');
								$(form).submit();
							}
						},
						no: {
							label: Lang.get('extrax2-webadmin.no'),
							className: "btn btn-danger bootbox-btn",
							callback: function () {
								$(form).submit();
							}
						}
					}
				});
			} else if (form.id === "table_participants_detail_form") {
				validator.getFormData(form).done(function (data) {

					var action = form.action;
					if ($('.tt-selected-id').val() === '') {
						action += '/0';
					}
					ajax.ajaxCallDeferred(action + '/checkotherdata', 'POST', data.replace('_method=PUT', ''), false).done(function (existingData) {

						if (ajax.ajaxSucceeded(existingData)) {
							if (existingData !== '') {

								bootbox.dialog({
									message: Lang.get('extrax2-webadmin.saving_participant_not_possible_desc', {'message_text': existingData}),
									title: Lang.get('extrax2-webadmin.saving_participant_not_possible', {'participant': '<span class="font-red-intense">' + $('#medical_practice_name').val() + '</span>'}),
									buttons: {
										ok: {
											label: Lang.get('extrax2-webadmin.ok'),
											className: "btn blue",
											callback: function () {
											}
										}
									}
								});

							} else {
								// Checkbox "Nur BETA-Tester anzeigen" zurücksetzen
								if ($('#content').find('.tt-content-datatable').length) {
									$('#content').find('.tt-content-datatable').find('.md-check').prop('checked', false);
								}
								$(form).submit();
							}
						}
					});
				});
			} else {
				$(form).submit();
			}
		}
	});

	// Löschen Button
	$('body').on('click', '.tt-delete,.tt-delete-value-modal', function (e) {
		e.preventDefault();

		var table = $(this).parents('.portlet').find('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail,.tt-datatable-dialog,.tt-datatable-data,.dd');

		if ($(this).hasClass('tt-delete-dialog')) {
			event.stopPropagation();
		}

		var title = 'TODO';
		var content = 'TODO';
		var element = $(this);
		var aPos = $(this).parents('.portlet').find('.tt-content-datatable').find('.tt-selected-pos').val();
		var id = $(this).parents('.portlet').find('.tt-content-datatable').find('.tt-selected-id').val();

		checkForExistingData(element, table, id, aPos).done(function (existing, additionalText) {

			if (existing) {
				return;
			}

			// Muss für jeden Bereich definiert werden!
			if (table[0].id === "table_users") {
				title = "<i class='icon-trash-o'></i>  " + Lang.get('extrax2-webadmin.delete_user', {'username': '<span class="font-red-intense">\'' + $("#username").val() + '\'</span>'});
				content = Lang.get('extrax2-webadmin.delete_user_desc');
			} else if (table[0].id === "table_projects") {
				title = "<i class='icon-trash-o'></i>  " + Lang.get('extrax2-webadmin.delete_project', {'projectname': '<span class="font-red-intense">\'' + $("#projectname").val() + '\'</span>'});
				content = Lang.get('extrax2-webadmin.delete_project_desc');
			} else if (table[0].id === "table_participants") {
				title = "<i class='icon-trash-o'></i>  " + Lang.get('extrax2-webadmin.delete_participant', {'participant': '<span class="font-red-intense">\'' + $("#medical_practice_name").val() + '\'</span>'});
				content = Lang.get('extrax2-webadmin.delete_participant_desc');
			} else if (table[0].id === "table_commission_recipients") {
				title = "<i class='icon-trash-o'></i>  " + Lang.get('extrax2-webadmin.delete_commission_recipient', {'commission_recipient': '<span class="font-red-intense">\'' + $("#address1").val() + ' ' + $("#address2").val() + '\'</span>'});
				content = Lang.get('extrax2-webadmin.delete_commission_recipient_desc');
			} else if (table[0].id === "table_email_recipients") {
				var aData = element.parents('.portlet').find('.tt-content-datatable').find('.tt-datatable,.tt-datatable-data').dataTable().fnGetData(aPos);
				var emailRecipientText = aData[2];
				if (aData[6] === 1 || aData[6] === '1') {
					emailRecipientText = trans('extrax2-webadmin.active_participants');
				} else if (aData[7] === '1' || aData[7] === 1) {
					emailRecipientText = aData[2] + ' (' + trans('extrax2-webadmin.project_partner_contact1') + ')';
				} else if (aData[8] === '1' || aData[8] === 1) {
					emailRecipientText = aData[2] + ' (' + trans('extrax2-webadmin.project_partner_contact2') + ')';
				} else if (aData[4] !== null && aData[4] !== '') {
					emailRecipientText = aData[2] + ' (' + trans('extrax2-webadmin.project_partner') + ')';
				} else if (aData[5] !== null && aData[5] !== '') {
					emailRecipientText = aData[2] + ' (' + trans('extrax2-webadmin.user') + ')';
				}
				title = "<i class='icon-trash-o'></i>  " + Lang.get('extrax2-webadmin.delete_email_recipient', {'email_recipient': '<span class="font-red-intense">\'' + emailRecipientText + '\'</span>'});
				content = Lang.get('extrax2-webadmin.delete_email_recipient_desc');
			} else if (table[0].id === "table_software_versions") {
				title = "<i class='icon-trash-o'></i>  " + Lang.get('extrax2-webadmin.delete_software_version', {'version': '<span class="font-red-intense">\'' + $("#version").val() + '\'</span>'});
				content = Lang.get('extrax2-webadmin.delete_software_version_desc');
			}

			bootbox.dialog({
				message: content,
				title: title,
				buttons: {
					success: {
						label: Lang.get('extrax2-webadmin.yes'),
						className: "btn-success",
						callback: function () {
							if (table.hasClass('tt-datatable-detail') || table.hasClass('tt-datatable-dialog')) {
								table.dataTable().fnDeleteRow(aPos);

								$("#content-detail").find('.tt-content-datatable').find('.tt-update').addClass('disabled');
								$("#content-detail").find('.tt-content-datatable').find('.tt-update').prop('disabled', 'disabled');
								$("#content-detail").find('.tt-content-datatable').find('.tt-delete').addClass('disabled');
								$("#content-detail").find('.tt-content-datatable').find('.tt-delete').prop('disabled', 'disabled');

								element.parents('.modal-content').find('.tt-content-datatable').find('.tt-delete').addClass('disabled');
								element.parents('.modal-content').find('.tt-content-datatable').find('.tt-delete').prop('disabled', 'disabled');
								element.parents('.modal-content').find('.widget-dialog-title').removeClass('hide');
								element.parents('.modal-content').find('.widget-dialog-content').addClass('hide');

							} else {
								ajax.ajaxCall(element[0].getAttribute("action") + "/" + $('#content-detail').find('.tt-selected-id').val(), element[0].getAttribute("method"), '_method=DELETE', false, function (data) {

									element.parents('.portlet').find('.tt-content-datatable').find(".tt-datatable-search").val("");
									element.parents('.portlet').find('.tt-content-datatable').find('.tt-datatable').dataTable().fnFilterClear();
									element.parents('.portlet').find('.tt-content-datatable').find('.tt-delete').addClass('disabled');
									element.parents('.portlet').find('.tt-content-datatable').find('.tt-delete').prop('disabled', 'disabled');
									utils.setHtmlData($("#content-detail"), data, true);
								});
							}
						}
					},
					danger: {
						label: Lang.get('extrax2-webadmin.no'),
						className: "btn-danger",
						callback: function () {
						}
					}
				}
			});
		});
	});

	// Abbrechen Button
	$('body').on('click', '.tt-cancel', function (e) {
		e.preventDefault();

		var element = $(this);

		ajax.ajaxCall($(this)[0].getAttribute("action"), $(this)[0].getAttribute("method"), null, false, function (data) {

			if ($('#content').find('.tt-content-datatable').length) {
				$('#content').find('.tt-content-datatable').find('.tt-datatable-search').val("");
				$('#content').find('.tt-content-datatable').find('.tt-datatable-search').removeClass('edited');
				$('#content').find('.tt-content-datatable').find('.md-check').prop('checked', false);
				$('#content').find('.tt-content-datatable').find('.tt-datatable').dataTable().fnFilterClear();
				$('#content').find('.tt-content-datatable').parents('.portlet').find('.tt-delete').addClass('disabled');
				$('#content').find('.tt-content-datatable').parents('.portlet').find('.tt-delete').prop('disabled', 'disabled');
				utils.setHtmlData($("#content-detail"), data, true);
			} else {
				utils.setHtmlData($("#content"), data, true);
			}
		});
	});

	// Tabellen Zeile & Tabellen Zeile Doppelklick
	$('body').on('click', '.tt-datatable:not(.tt-tree-datatable,.tt-datatable-not-clickable) tbody td,.tt-datatable-data:not(.tt-tree-datatable,.tt-datatable-not-clickable) tbody td', function (e) {
		e.preventDefault();

		var element = $(this);
		var parentElement = $(this).parent();

		if (parentElement.hasClass('clicked')) {
			parentElement.removeClass('clicked');
			$.when.apply($, utils.GLOBALS.runningTableClickRequests).done(function () {
				utils.GLOBALS.runningTableClickRequests.push(changes.tableSingleClick(parentElement, element).done(function () {
					utils.GLOBALS.runningTableClickRequests.length = 0;
					changes.tableDoubleClick(element);
				}));
			});
		} else {
			parentElement.addClass('clicked');
			setTimeout(function () {
				if (parentElement.hasClass('clicked')) {
					parentElement.removeClass('clicked');
					utils.GLOBALS.runningTableClickRequests.push(changes.tableSingleClick(parentElement, element).done(function () {
						utils.GLOBALS.runningTableClickRequests.length = 0;
					}));
				}
			}, 200);
		}
	});

	// Tabelle zurück Button
	$('body').on('click', '.tt-datatable-previous', function (e) {
		e.preventDefault();

		$(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail,.tt-datatable-dialog,.tt-datatable-data').dataTable().fnPageChange('previous');
	});

	// Tabelle weiter Button
	$('body').on('click', '.tt-datatable-next', function (e) {
		e.preventDefault();

		$(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail,.tt-datatable-dialog,.tt-datatable-data').dataTable().fnPageChange('next');

		//initialize.initializeSelect2($(this).parents('.tt-content-datatable').find('.tt-select2:not(.select2-container)'));
	});

	// Tabelle Suche
	$('body').on('keyup', '.tt-datatable-search', function (e) {
		e.preventDefault();
		var code = e.keyCode || e.which;
		if (code == 13) {
			if ($(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail,.tt-datatable-data')[0].id === 'table_request_history') {
				$(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail,.tt-datatable-data').DataTable().search('', true, true).draw();
			} else {
				let searchTerm = $(this).val().replace(/"/g, '\\b');

				if (!isNaN(searchTerm)){
					$(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail,.tt-datatable-data').DataTable().search('', true, true).draw();
				}
				else {
					$(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail,.tt-datatable-data').DataTable().search(searchTerm, true, true).draw();
				}
			}
		}
		if ($(this).parent().find('.tt-clear-search').length) {
			if ($(this).val().length) {
				$(this).parent().find('.tt-clear-search').removeClass('hide');
			} else {
				$(this).parent().find('.tt-clear-search').addClass('hide');
			}
		}
	});

	// Benutzer sperren Button
	$('body').on('click', '.tt-lock-user,.tt-lock-project', function (e) {
		e.preventDefault();

		var element = $(this);

		ajax.ajaxCall($(this)[0].getAttribute('action'), $(this)[0].getAttribute('method'), null, false, function (data) {
			$('#content').find('.tt-content-datatable').find('.tt-datatable').dataTable().fnStandingRedraw();
			utils.setHtmlData($("#content-detail"), data, true);
		});
	});

	// Tab Überschrift ändern aufgrund ob Recht vergeben oder nicht
	$('body').on('change', '.tt-project-right,.tt-project-right-external', function (e) {
		e.preventDefault();

		if ($(this).is(':checked')) {
			if ($(this).hasClass('tt-project-right-external')) {
				$.each($($(this).parents('.tab-pane')[0]).find('.tt-project-right'), function (i, checkbox) {
					$(checkbox).removeAttr('checked');
				});
			} else {
				$.each($($(this).parents('.tab-pane')[0]).find('.tt-project-right-external'), function (i, checkbox) {
					$(checkbox).removeAttr('checked');
				});
			}
		}

		var checked = $(this).parents('.tab-pane').find('.tt-project-right:checked,.tt-project-right-external:checked').length;

		if (checked) {
			$('[href="#' + $(this).parents('.tab-pane')[0].id + '"]').addClass('tt-project-right-selected');
		} else {
			$('[href="#' + $(this).parents('.tab-pane')[0].id + '"]').removeClass('tt-project-right-selected');
		}
	});

	// Alles an- bzw. abhaken
	$('body').on('click', '.tt-check-none,.tt-check-all', function (e) {
		e.preventDefault();

		var element = $(this);

		$.each($($(this).parents('.tab-pane')[0]).find('.tt-project-right,.tt-project-right-external,.tt-data-category,.tt-validation'), function (i, checkbox) {
			if (element.hasClass('tt-check-all')) {
				if ($(checkbox).hasClass('tt-project-right-external')) {
					$(checkbox).removeAttr('checked');
				} else {
					$(checkbox).prop('checked', 'checked');
				}
				if ($(checkbox).hasClass('tt-project-right')) {
					$('[href="#' + element.parents('.tab-pane')[0].id + '"]').addClass('tt-project-right-selected');
				}
			} else {
				$(checkbox).removeAttr('checked');
				if ($(checkbox).hasClass('tt-project-right')) {
					$('[href="#' + element.parents('.tab-pane')[0].id + '"]').removeClass('tt-project-right-selected');
				}
			}
		});
	});

	// Alles in einer Liste an- bzw. abhaken
	$('body').on('click', '.tt-check-none-list,.tt-check-all-list', function (e) {
		e.preventDefault();

		var element = $(this);
		var table = $(this).parents('.tt-content-datatable').find('table').DataTable();

		var tableData = table.data().each(function (row) {
			row.selection = element.hasClass('tt-check-all-list');
		});
		table.draw(false);
	});

	$('body').on('change', '.tt-list-selection', function (e) {
		e.preventDefault();

		var element = $(this);
		var table = $(this).parents('.tt-content-datatable').find('table').DataTable();

		var row = table.row(element.parents('tr')).data();
		row.selection = element.is(':checked');
	});

	// Mandatsreferenz erzeugen
	$('body').on('click', '.tt-create-membershipnumber,.tt-create-membershipnumber_invoice', function (e) {
		e.preventDefault();

		var lexwareNumber = $('#customer_id_lexware').val();
		if ($(this).hasClass('tt-create-membershipnumber_invoice')) {
			lexwareNumber = $('#customer_id_lexware_invoice').val();
		}

		if (lexwareNumber.length) {
			if ($(this).hasClass('tt-create-membershipnumber_invoice')) {
				$('#membershipnumber_invoice').val(lexwareNumber + '001');
				$('#membershipnumber_invoice').addClass('edited');
			} else {
				$('#membershipnumber').val(lexwareNumber + '001');
				$('#membershipnumber').addClass('edited');
			}
		} else {
			bootbox.dialog({
				message: Lang.get('extrax2-webadmin.lexware_number_missing'),
				title: Lang.get('extrax2-webadmin.create_membershipnumber'),
				buttons: {
					ok: {
						label: Lang.get('extrax2-webadmin.ok'),
						className: "btn blue",
						callback: function () {
						}
					}
				}
			});
		}
	});

	// Identifikationsnummer erzeugen
	$('body').on('click', '.tt-create-guid', function (e) {
		e.preventDefault();

		ajax.ajaxCall('admin/participants/guid', 'GET', null, false, function (data) {
			if (data !== null) {
				$('#identificationnumber').val(data);
				$('#identificationnumber').addClass('edited');
			}
		});
	});

	// Identifikationsnummer erzeugen
	$('body').on('click', '.tt-create-elpax-token', function (e) {
		e.preventDefault();

		ajax.ajaxCall('admin/participants/elpax-token', 'GET', null, false, function (data) {
			if (data !== null) {
				$('#facility').val(data);
				$('#facility').addClass('edited');
			}
		});
	});

	// Tab Überschrift ändern aufgrund ob Recht vergeben oder nicht
	$('body').on('change', '[name="demo_license"]', function (e) {
		e.preventDefault();

		if (this.checked) {
			$('#first_letter_patient').removeAttr('disabled');
			$('#max_patient_number').removeAttr('disabled');
		} else {
			$('#first_letter_patient').prop('disabled', 'disabled');
			$('#first_letter_patient').val('');
			$('#first_letter_patient').removeClass('edited');
			$('#max_patient_number').prop('disabled', 'disabled');
			$('#max_patient_number').val('');
			$('#max_patient_number').removeClass('edited');
		}
	});

	// Liste Zeile Klick
	$('body').on('click', '.mt-list-item .col, .mt-list-item .row-editable', function (e) {

		if ($(this).find('.md-radio-inline').length <= 0 && $(this).find('.md-checkbox').length <= 0 && $(this).find('.tt-file-upload').length <= 0) {
			e.preventDefault();
		}

		$($(this).parents('.mt-list-container')[0]).find('.mt-list-item').removeClass('active');
		$($(this).parents('.mt-list-item')[0]).addClass('active');

		$(this).parents('.mt-element-list').find('.tt-list-button').removeAttr('disabled');
	});

	// Doppelklick auf Listenzeile - falls nur ein Listenbutton vorhanden, dann diesen anklicken
	$('body').on('dblclick', '.mt-list-item .col, .mt-list-item .row-editable', function (e) {
		e.preventDefault();

		if ($(this).parents('.mt-element-list').find('.tt-list-button:not(.tt-delete-list)').length === 1) {
			$($(this).parents('.mt-element-list').find('.tt-list-button:not(.tt-delete-list)')[0]).click();
		}
	});

	// Liste Zeile Löschen
	$('body').on('click', '.tt-delete-list', function (e) {
		e.preventDefault();

		var table = $(this).parents('.mt-element-list');
		var id = $(this).parents('.mt-element-list').find('.mt-list-container .mt-list-item.active').data().tableId;

		checkForExistingListData(table, id).done(function (existing) {

			if (existing) {
				return;
			}
			$(table).find('.tt-list-button').prop('disabled', 'disabled');
			$(table).find('.mt-list-container .mt-list-item.active').remove();
		});
	});

	// Vertrag anzeigen
	$('body').on('click', '.tt-contract', function (e) {
		e.preventDefault();

		utils.updateGlobals('programmaticChange', true);

		utils.resetForm($('#portlet_contract_section'));
		$('#table_contracts_detail_form').find('.tab-pane').removeClass('active');
		$('#table_contracts_detail_form').find('.nav-tabs li').removeClass('active');
		$('#tab_contract_data').addClass('active');
		$($('#table_contracts_detail_form').find('.nav-tabs li')[0]).addClass('active');
		$('#voucher_name').prop('disabled', 'disabled');

		var listItem = $($(this).parents('.mt-element-list').find('.mt-list-container .mt-list-item.active')[0]);

		validator.checkForOneTimeUsage($('[name="use_default_account_settings"]')[0].checked, listItem.find('[name^="invoice_recipient_"]').val(), listItem.find('[name^="start_date_"]').val(), $('[name="charging_by"]:checked').val(), listItem.find('[name^="reseller_id_"]').val())
			.done(function (isOneTimeUsage) {

				$('#portlet_contract_section').find('.caption-subject').text(trans('extrax2-webadmin.title_contract', {'participant': $('#medical_practice_name').val() + ' - ' + listItem.find('[name^="doctor_name_"]').val() + ' (' + listItem.find('[name^="bsnr_"]').val() + '-' + listItem.find('[name^="lanr_"]').val() + ')'}));
				if (listItem.find('[name^="voucher_code_"]').val().length) {
					$('#voucher_code').val(listItem.find('[name^="voucher_code_"]').val());
					$('#voucher_code').addClass('edited');
				}
				if (listItem.find('[name^="start_date_"]').val().length) {
					$('#start_date').data('picker').setDate(utils.stringToDate(listItem.find('[name^="start_date_"]').val()));
					$('#start_date').addClass('edited');
				}
				if (listItem.find('[name^="invoice_recipient_"]').val().length) {
					if (listItem.find('[name^="invoice_recipient_"]').val() === 'reseller') {
						$('#invoice_recipient').select2().val(listItem.find('[name^="invoice_recipient_"]').val() + '_' + listItem.find('[name^="reseller_id_"]').val()).trigger("change");
					} else {
						$('#invoice_recipient').select2().val(listItem.find('[name^="invoice_recipient_"]').val()).trigger("change");
					}
				}
				if (!isOneTimeUsage) {
					if (listItem.find('[name^="contract_date_"]').val().length) {
						$('#contract_date').data('picker').setDate(utils.stringToDate(listItem.find('[name^="contract_date_"]').val()));
						$('#contract_date').addClass('edited');
					}
					if (listItem.find('[name^="minimum_duration_"]').val().length) {
						$('#minimum_duration').val(listItem.find('[name^="minimum_duration_"]').val());
						$('#minimum_duration').addClass('edited');
					}
					if (listItem.find('[name^="duration_"]').val().length) {
						$('#duration').val(listItem.find('[name^="duration_"]').val());
						$('#duration').addClass('edited');
					}
					if (listItem.find('[name^="accounting_period_"]').val().length) {
						$('#accounting_period').val(listItem.find('[name^="accounting_period_"]').val());
						$('#accounting_period').addClass('edited');
					}
					if (listItem.find('[name^="maturity_"]').val().length) {
						$('#maturity').select2().val(listItem.find('[name^="maturity_"]').val()).trigger('change');
					}
					if (listItem.find('[name^="notice_"]:not([name^="notice_date_"],[name^="notice_time_unit_"])').val().length) {
						$('#notice').val(listItem.find('[name^="notice_"]:not([name^="notice_date_"],[name^="notice_time_unit_"])').val());
						$('#notice').addClass('edited');
					}
					if (listItem.find('[name^="notice_time_unit_"]').val().length) {
						$('#notice_time_unit').select2().val(listItem.find('[name^="notice_time_unit_"]').val()).trigger('change');
					}
					if (listItem.find('[name^="reference_date_"]').val().length) {
						$('#reference_date').select2().val(listItem.find('[name^="reference_date_"]').val()).trigger('change');
					}
					if (listItem.find('[name^="notice_date_"]').val().length) {
						$('#notice_date').data('picker').setDate(utils.stringToDate(listItem.find('[name^="notice_date_"]').val()));
						$('#notice_date').addClass('edited');
					}
					if (listItem.find('[name^="validity_date_"]').val().length) {
						$('#validity_date').data('picker').setDate(utils.stringToDate(listItem.find('[name^="validity_date_"]').val()));
						$('#validity_date').addClass('edited');
					}
					if (listItem.find('[name^="last_export_date_"]').val().length) {
						$('#last_export_date').data('picker').setDate(utils.stringToDate(listItem.find('[name^="last_export_date_"]').val()));
						$('#last_export_date').addClass('edited');
					}
					if (listItem.find('[name^="drawn_up_account_end_date_"]').val().length) {
						$('#validity_date').data('minValidityDate', listItem.find('[name^="drawn_up_account_end_date_"]').val());
					}
				}
				if (listItem.find('[name^="customer_order_"]').val().length) {
					$('#customer_order').val(listItem.find('[name^="customer_order_"]').val());
					$('#customer_order').addClass('edited');
				}
				if (listItem.find('[name^="first_commission_recipient_"]').val().length && $('#first_commission_recipient').length) {
					$('#first_commission_recipient').select2().val(listItem.find('[name^="first_commission_recipient_"]').val()).trigger('change');
				}
				if (listItem.find('[name^="first_commission_rate_"]').val().length && $('#first_commission_rate').length) {
					$('#first_commission_rate').select2().val(listItem.find('[name^="first_commission_rate_"]').val()).trigger('change');
				}
				if (listItem.find('[name^="second_commission_recipient_"]').val().length && $('#second_commission_recipient').length) {
					$('#second_commission_recipient').select2().val(listItem.find('[name^="second_commission_recipient_"]').val()).trigger('change');
				}
				if (listItem.find('[name^="second_commission_rate_"]').val().length && $('#second_commission_rate').length) {
					$('#second_commission_rate').select2().val(listItem.find('[name^="second_commission_rate_"]').val()).trigger('change');
				}

				$('.tt-content').addClass('hide');
				$('.tt-content-contract').removeClass('hide');
				utils.setPortletMaxHeight();

				utils.updateGlobals('programmaticChange', false);
			});
	});

	// Gutscheincode en- / disablen
	$('body').on('change', '#invoice_recipient', function (e) {
		e.preventDefault();

		if (/^reseller_/.test($(this).select2().val())) {
			$('#voucher_code').removeAttr('disabled');
		} else {
			$('#voucher_code').prop('disabled', 'disabled');
			$('#voucher_code').val('');
			$('#voucher_code').removeClass('edited');
		}
	});

	// Fachgruppen und Staffel en- / disablen
	$('body').on('change', '[name^="lanr_bsnr"]', function (e) {
		e.preventDefault();

		if ($(this).val() == 'lanr' && this.checked) {
			$($(this).parents('.mt-list-item,.modal-body')[0]).find('[name^="professional_groups_only_once"]').removeAttr('disabled');
			$($(this).parents('.mt-list-item,.modal-body')[0]).find('[name^="from_number_of_lanr_bsnr"]').removeAttr('disabled');
		} else if (($(this).val() == 'bsnr' || $(this).val() == 'account_id') && this.checked) {
			$($(this).parents('.mt-list-item,.modal-body')[0]).find('[name^="professional_groups_only_once"]').removeAttr('checked');
			$($(this).parents('.mt-list-item,.modal-body')[0]).find('[name^="professional_groups_only_once"]').prop('disabled', 'disabled');
			$($(this).parents('.mt-list-item,.modal-body')[0]).find('[name^="from_number_of_lanr_bsnr"]').removeAttr('disabled');
		} else if ($(this).val() == 'fixed' && this.checked) {
			$($(this).parents('.mt-list-item,.modal-body')[0]).find('[name^="professional_groups_only_once"]').removeAttr('checked');
			$($(this).parents('.mt-list-item,.modal-body')[0]).find('[name^="professional_groups_only_once"]').prop('disabled', 'disabled');
			$($(this).parents('.mt-list-item,.modal-body')[0]).find('[name^="from_number_of_lanr_bsnr"]').val('');
			$($(this).parents('.mt-list-item,.modal-body')[0]).find('[name^="from_number_of_lanr_bsnr"]').removeClass('edited');
			$($(this).parents('.mt-list-item,.modal-body')[0]).find('[name^="from_number_of_lanr_bsnr"]').prop('disabled', 'disabled');
		}
	});

	// Abrechnung nach ändern => Liste der Standardabrechnung ändern
	$('body').on('change', '[name="charging_by"]', function (e) {
		e.preventDefault();

		if (this.checked && this.value == 'bsnr') {
			$('#tab_participant_account_data .tt-bsnr').removeClass('hide');
			$('#tab_participant_account_data .tt-account_id').addClass('hide');
			$('#tab_participant_account_data .tt-lanr').addClass('hide');
		} else if (this.checked && this.value == 'lanr') {
			$('#tab_participant_account_data .tt-bsnr').addClass('hide');
			$('#tab_participant_account_data .tt-account_id').addClass('hide');
			$('#tab_participant_account_data .tt-lanr').removeClass('hide');
		} else if (this.checked && this.value == 'account_id') {
			$('#tab_participant_account_data .tt-bsnr').addClass('hide');
			$('#tab_participant_account_data .tt-account_id').removeClass('hide');
			$('#tab_participant_account_data .tt-lanr').addClass('hide');
		}

		if (this.checked && (this.value == 'bsnr' || this.value == 'lanr')) {
			$('#table_participant_lanr_bsnr .title-account-id').addClass('hide');
			$('#table_participant_lanr_bsnr .title-main-bsnr').removeClass('hide');
			$('#table_participant_lanr_bsnr .input-group-account-id input').val('');
			$('#table_participant_lanr_bsnr .input-group-account-id').addClass('hide');
			$('#table_participant_lanr_bsnr .check-account-id').addClass('hide');
			$('#table_participant_lanr_bsnr .check-main-bsnr').removeClass('hide');
			$('#table_participant_lanr_bsnr .box-account-id').addClass('hide');
			$('#table_participant_lanr_bsnr .box-main-bsnr').removeClass('hide');
			$('#table_participant_lanr_bsnr .tt-main-lanr-bsnr').removeAttr('checked');
		} else if (this.checked && this.value == 'account_id') {
			$('#table_participant_lanr_bsnr .title-account-id').removeClass('hide');
			$('#table_participant_lanr_bsnr .title-main-bsnr').addClass('hide');
			$('#table_participant_lanr_bsnr .input-group-account-id').removeClass('hide');
			$('#table_participant_lanr_bsnr .check-account-id').removeClass('hide');
			$('#table_participant_lanr_bsnr .check-main-bsnr').addClass('hide');
			$('#table_participant_lanr_bsnr .box-account-id').removeClass('hide');
			$('#table_participant_lanr_bsnr .box-main-bsnr').addClass('hide');
			$('#table_participant_lanr_bsnr .tt-main-lanr-bsnr').removeAttr('checked');
		}
	});

	// Standardabrechnung ändern => Standardpreise oder eigene Preise anzeigen
	$('body').on('change', '[name="use_default_account_settings"]', function (e) {
		e.preventDefault();

		if (this.checked) {
			$('#tab_participant_account_data .mt-list-title,#tab_project_partner_account_data .mt-list-title,#tab_reseller_account_data .mt-list-title').addClass('hide');
			$('#tab_participant_account_data .tt-default-accounting,#tab_project_partner_account_data .tt-default-accounting,#tab_reseller_account_data .tt-default-accounting').removeClass('hide');
			$('#tab_participant_account_data .tt-custom-accounting,#tab_project_partner_account_data .tt-custom-accounting,#tab_reseller_account_data .tt-custom-accounting').addClass('hide');
		} else {
			$('#tab_participant_account_data .mt-list-title,#tab_project_partner_account_data .mt-list-title,#tab_reseller_account_data .mt-list-title').removeClass('hide');
			$('#tab_participant_account_data .tt-default-accounting,#tab_project_partner_account_data .tt-default-accounting,#tab_reseller_account_data .tt-default-accounting').addClass('hide');
			$('#tab_participant_account_data .tt-custom-accounting,#tab_project_partner_account_data .tt-custom-accounting,#tab_reseller_account_data .tt-custom-accounting').removeClass('hide');
		}
		utils.setDetailPortletMaxHeight();
	});

	// Standard Mindestabnahmemenge ändern => Standard Mindestabnahmemenge oder eigene Mindestabnahmemenge anzeigen
	$('body').on('change', '[name="use_default_minimum_payment"]', function (e) {
		e.preventDefault();

		if (this.checked) {
			$('#tab_participant_account_data .tt-default-minimum-payment,#tab_project_partner_account_data .tt-default-minimum-payment,#tab_reseller_account_data .tt-default-minimum-payment').removeClass('hide');
			$('#tab_participant_account_data .tt-custom-minimum-payment,#tab_project_partner_account_data .tt-custom-minimum-payment,#tab_reseller_account_data .tt-custom-minimum-payment').addClass('hide');
		} else {
			$('#tab_participant_account_data .tt-default-minimum-payment,#tab_project_partner_account_data .tt-default-minimum-payment,#tab_reseller_account_data .tt-default-minimum-payment').addClass('hide');
			$('#tab_participant_account_data .tt-custom-minimum-payment,#tab_project_partner_account_data .tt-custom-minimum-payment,#tab_reseller_account_data .tt-custom-minimum-payment').removeClass('hide');
		}
		utils.setDetailPortletMaxHeight();
	});

	// Lizenzaktivierung an- abhaken ==> Felder aktivieren / deaktivieren
	$('body').on('change', '[name="activation_license"]', function (e) {
		e.preventDefault();

		if (this.checked) {
			$('#activation_hotline_phone').removeAttr('disabled');
			$('#activation_hotline_company').removeAttr('disabled');
			$('#activation_hotline_opening_hours').removeAttr('disabled');
			$('#activation_hotline_email').removeAttr('disabled');
			$('#activation_period_of_validity').removeAttr('disabled');
		} else {
			$('#activation_hotline_phone').prop('disabled', 'disabled');
			$('#activation_hotline_phone').removeClass('edited');
			$('#activation_hotline_phone').val('');
			$('#activation_hotline_company').prop('disabled', 'disabled');
			$('#activation_hotline_company').removeClass('edited');
			$('#activation_hotline_company').val('');
			$('#activation_hotline_opening_hours').prop('disabled', 'disabled');
			$('#activation_hotline_opening_hours').removeClass('edited');
			$('#activation_hotline_opening_hours').val('');
			$('#activation_hotline_email').prop('disabled', 'disabled');
			$('#activation_hotline_email').removeClass('edited');
			$('#activation_hotline_email').val('');
			$('#activation_period_of_validity').prop('disabled', 'disabled');
			$('#activation_period_of_validity').removeClass('edited');
			$('#activation_period_of_validity').val('');
		}
	});

	// Vor Übermittlung Verbindung zum Lizenzserver herstellen an- abhaken ==> Felder aktivieren / deaktivieren
	$('body').on('change', '[name="connect_to_license_server"]', function (e) {
		e.preventDefault();

		if (this.checked) {
			$('#grace_period').removeAttr('disabled');
			$('#check_period').removeAttr('disabled');
		} else {
			$('#grace_period').prop('disabled', 'disabled');
			$('#grace_period').removeClass('edited');
			$('#grace_period').val('');
			$('#check_period').prop('disabled', 'disabled');
			$('#check_period').removeClass('edited');
			$('#check_period').val('');
		}
	});

	// Upload an- abhaken ==> Felder aktivieren / deaktivieren
	$('body').on('change', '[name="upload"]', function (e) {
		e.preventDefault();

		if (this.checked) {
			$('#upload_type_https').removeAttr('disabled');
			$('#upload_type_ftps').removeAttr('disabled');
			$('#upload_type_sftp').removeAttr('disabled');
			$('#upload_server').removeAttr('disabled');
			$('#use_signed_upload_url').removeAttr('disabled');
			$('#upload_port').removeAttr('disabled');
			$('#upload_user_name').removeAttr('disabled');
			$('#upload_password').removeAttr('disabled');
			$('#upload_file_path').removeAttr('disabled');
			$('#upload_parameter_name').removeAttr('disabled');
			$('#upload_via_dll').removeAttr('disabled');
		} else {
			$('#upload_type_https').prop('disabled', 'disabled');
			$('#upload_type_https').removeAttr('checked');
			$('#upload_type_ftps').prop('disabled', 'disabled');
			$('#upload_type_ftps').removeAttr('checked');
			$('#upload_type_sftp').prop('disabled', 'disabled');
			$('#upload_type_sftp').removeAttr('checked');
			$('#upload_server').prop('disabled', 'disabled');
			$('#upload_server').removeClass('edited');
			$('#upload_server').val('');
			$('#use_signed_upload_url').prop('disabled', 'disabled');
			$('#use_signed_upload_url').removeAttr('checked');
			$('#upload_port').prop('disabled', 'disabled');
			$('#upload_port').removeClass('edited');
			$('#upload_port').val('');
			$('#upload_user_name').prop('disabled', 'disabled');
			$('#upload_user_name').removeClass('edited');
			$('#upload_user_name').val('');
			$('#upload_password').prop('disabled', 'disabled');
			$('#upload_password').removeClass('edited');
			$('#upload_password').val('');
			$('#upload_file_path').prop('disabled', 'disabled');
			$('#upload_file_path').removeClass('edited');
			$('#upload_file_path').val('');
			$('#upload_parameter_name').prop('disabled', 'disabled');
			$('#upload_parameter_name').removeClass('edited');
			$('#upload_parameter_name').val('');
			$('#upload_via_dll').prop('disabled', 'disabled');
			$('#upload_via_dll').removeAttr('checked');
			$('#upload_ftps_type_explicit').prop('disabled', 'disabled');
			$('#upload_ftps_type_explicit').removeAttr('checked');
			$('#upload_ftps_type_implicit').prop('disabled', 'disabled');
			$('#upload_ftps_type_implicit').removeAttr('checked');
			$('#upload_ftps_passive_mode').prop('disabled', 'disabled');
			$('#upload_ftps_passive_mode').removeAttr('checked');
			$('.tt-upload-ftps').addClass('hide');
			$('.tt-upload-https').addClass('hide');
		}
		utils.setPortletMaxHeight();
	});

	$('body').on('change', '[name="use_signed_upload_url"]', function (e) {
		e.preventDefault();

		if (this.checked) {
			$('#request_url').removeAttr('disabled');
			$('#api_key').removeAttr('disabled');
         $('#upload_server').prop('disabled', 'disabled');
         $('#upload_server').removeClass('edited');
         $('#upload_server').val('');
		} else {
			$('#request_url').prop('disabled', 'disabled');
			$('#request_url').removeClass('edited');
			$('#request_url').val('');
         $('#api_key').prop('disabled', 'disabled');
         $('#api_key').removeClass('edited');
         $('#api_key').val('');
         $('#upload_server').removeAttr('disabled');
		}
		utils.setPortletMaxHeight();
	});

	$('body').on('change', '[name="upload_type"]', function (e) {
		e.preventDefault();

		if ($('#upload_type_ftps')[0].checked) {
			$('#upload_ftps_type_explicit').removeAttr('disabled');
			$('#upload_ftps_type_implicit').removeAttr('disabled');
			$('#upload_ftps_passive_mode').removeAttr('disabled');
			$('.tt-upload-ftps').removeClass('hide');
			$('.tt-upload-https').addClass('hide');
		} else {
			$('#upload_ftps_type_explicit').prop('disabled', 'disabled');
			$('#upload_ftps_type_explicit').removeAttr('checked');
			$('#upload_ftps_type_implicit').prop('disabled', 'disabled');
			$('#upload_ftps_type_implicit').removeAttr('checked');
			$('#upload_ftps_passive_mode').prop('disabled', 'disabled');
			$('#upload_ftps_passive_mode').removeAttr('checked');
		}
		if ($('#upload_type_https')[0].checked) {
			$('#upload_https_type_multipart').removeAttr('disabled');
			$('#upload_https_type_octet_stream').removeAttr('disabled');
			$('.tt-upload-ftps').addClass('hide');
			$('.tt-upload-https').removeClass('hide');
		} else {
			$('#upload_https_type_multipart').prop('disabled', 'disabled');
			$('#upload_https_type_multipart').removeAttr('checked');
			$('#upload_https_type_octet_stream').prop('disabled', 'disabled');
			$('#upload_https_type_octet_stream').removeAttr('checked');
		}
		utils.setPortletMaxHeight();
	});

	// Lizenzaktivierung an- abhaken ==> Felder aktivieren / deaktivieren
	$('body').on('change', '[name="encrypt"]', function (e) {
		e.preventDefault();

		if (this.checked) {
			$('#encrypt_upload_key').removeAttr('disabled');
			$('#encrypt_magic_word').removeAttr('disabled');
			$('#encrypt_key_index').removeAttr('disabled');
			$('#encrypt_id_id').removeAttr('disabled');
			$('#encrypt_id_fg').removeAttr('disabled');
		} else {
			$('#encrypt_upload_key').prop('disabled', 'disabled');
			$('#encrypt_upload_key').removeClass('edited');
			$('#encrypt_upload_key').val('');
			$('#encrypt_magic_word').prop('disabled', 'disabled');
			$('#encrypt_magic_word').removeClass('edited');
			$('#encrypt_magic_word').val('');
			$('#encrypt_key_index').prop('disabled', 'disabled');
			$('#encrypt_key_index').removeClass('edited');
			$('#encrypt_key_index').val('');
			$('#encrypt_id_id').prop('disabled', 'disabled');
			$('#encrypt_id_id').removeAttr('checked');
			$('#encrypt_id_fg').prop('disabled', 'disabled');
			$('#encrypt_id_fg').removeAttr('checked');
		}
	});

	// Schwellwerte anzeigen
	$('body').on('click', '.tt-thresholds', function (e) {
		e.preventDefault();

		var listItem = $($(this).parents('.mt-element-list').find('.mt-list-container .mt-list-item.active')[0]);

		if (listItem.find('[name^="threshold_hits_min_for_warning_"]').val().length) {
			$('#threshold_hits_min_for_warning').val(listItem.find('[name^="threshold_hits_min_for_warning_"]').val());
			$('#threshold_hits_min_for_warning').addClass('edited');
		}
		if (listItem.find('[name^="threshold_hits_min_for_error_"]').val().length) {
			$('#threshold_hits_min_for_error').val(listItem.find('[name^="threshold_hits_min_for_error_"]').val());
			$('#threshold_hits_min_for_error').addClass('edited');
		}
		if (listItem.find('[name^="threshold_patients_with_hits_min_for_warning_"]').val().length) {
			$('#threshold_patients_with_hits_min_for_warning').val(listItem.find('[name^="threshold_patients_with_hits_min_for_warning_"]').val());
			$('#threshold_patients_with_hits_min_for_warning').addClass('edited');
		}
		if (listItem.find('[name^="threshold_patients_with_hits_min_for_error_"]').val().length) {
			$('#threshold_patients_with_hits_min_for_error').val(listItem.find('[name^="threshold_patients_with_hits_min_for_error_"]').val());
			$('#threshold_patients_with_hits_min_for_error').addClass('edited');
		}
		if (listItem.find('[name^="threshold_hits_rel_min_for_warning_"]').val().length) {
			$('#threshold_hits_rel_min_for_warning').val(listItem.find('[name^="threshold_hits_rel_min_for_warning_"]').val());
			$('#threshold_hits_rel_min_for_warning').addClass('edited');
		}
		if (listItem.find('[name^="threshold_hits_rel_min_for_error_"]').val().length) {
			$('#threshold_hits_rel_min_for_error').val(listItem.find('[name^="threshold_hits_rel_min_for_error_"]').val());
			$('#threshold_hits_rel_min_for_error').addClass('edited');
		}
		if (listItem.find('[name^="threshold_patients_with_hits_rel_min_for_warning_"]').val().length) {
			$('#threshold_patients_with_hits_rel_min_for_warning').val(listItem.find('[name^="threshold_patients_with_hits_rel_min_for_warning_"]').val());
			$('#threshold_patients_with_hits_rel_min_for_warning').addClass('edited');
		}
		if (listItem.find('[name^="threshold_patients_with_hits_rel_min_for_error_"]').val().length) {
			$('#threshold_patients_with_hits_rel_min_for_error').val(listItem.find('[name^="threshold_patients_with_hits_rel_min_for_error_"]').val());
			$('#threshold_patients_with_hits_rel_min_for_error').addClass('edited');
		}
	});

	// Kürzel anzeigen
	$('body').on('click', '.tt-tokens', function (e) {
		e.preventDefault();

		var listItem = $($(this).parents('.mt-element-list').find('.mt-list-container .mt-list-item.active')[0]);
		var tableId = listItem.data().tableId;

		if (listItem.find('[name^="tokens_listtype_"]').val().length) {
			if (listItem.find('[name^="tokens_listtype_"]').val() === 'WhiteList') {
				$('#m_history_item_token_white_list').prop('checked', true);
			} else {
				$('#m_history_item_token_black_list').prop('checked', true);
			}
		}
		jQuery.each(listItem.find('[name^="history_item_token_pvs_id_' + listItem.data().tableId + '_"]'), function (i, element) {

			var listId = element.name.substr(element.name.lastIndexOf('_') + 1);
			var values = 'new_id=' + listId;
			values = values + '&license_history_item_id=' + tableId;
			values = values + '&history_item_token=' + encodeURIComponent(listItem.find('[name="history_item_token_' + tableId + '_' + listId + '"]').val());
			values = values + '&history_item_token_pvs_id=' + $(element).val();

			ajax.ajaxCallDeferred('admin/project/' + $('[name="project_id"]').val() + '/licenses/create_history_item_token', 'GET', values, false)
				.done(function (data) {
					if (ajax.ajaxSucceeded(data)) {
						$('#table_licenses_history_item_tokens_form .mt-list-container ul').append(data);
						initialize.initializeElements($('#table_licenses_history_item_tokens_form .mt-list-container ul'));
					}
				});
		});
	});

	// Kürzel / Maskenausdruck hinzufügen
	$('body').on('click', '.tt-add-token, .tt-add-mask-expression', function (e) {
		e.preventDefault();

		var listItem = $($('#tab_history_items').find('.mt-element-list .mt-list-container .mt-list-item.active')[0]);

		$('[name="license_history_item_id"]').val(listItem.data().tableId);
	});

	// Kürzel anzeigen
	$('body').on('click', '.tt-mask-expressions', function (e) {
		e.preventDefault();

		var listItem = $($(this).parents('.mt-element-list').find('.mt-list-container .mt-list-item.active')[0]);
		var tableId = listItem.data().tableId;

		jQuery.each(listItem.find('[name^="mask_expression_pvs_id_' + tableId + '_"]'), function (i, element) {

			var listId = element.name.substr(element.name.lastIndexOf('_') + 1);
			var values = 'new_id=' + listId;
			values = values + '&license_history_item_id=' + tableId;
			values = values + '&mask_expression_pvs_id=' + $(element).val();
			values = values + '&mask_expression_ident=' + encodeURIComponent(listItem.find('[name="mask_expression_ident_' + tableId + '_' + listId + '"]').val());
			values = values + '&mask_expression_expression=' + encodeURIComponent(listItem.find('[name="mask_expression_expression_' + tableId + '_' + listId + '"]').val());

			ajax.ajaxCallDeferred('admin/project/' + $('[name="project_id"]').val() + '/licenses/create_history_item_default_mask_expression', 'GET', values, false)
				.done(function (data) {
					if (ajax.ajaxSucceeded(data)) {
						$('#table_licenses_history_item_default_mask_expressions_form .mt-list-container ul').append(data);
						initialize.initializeElements($('#table_licenses_history_item_default_mask_expressions_form .mt-list-container ul'));
					}
				});
		});
	});

	// Neue Lizenz kaufen - Gutscheincode setzen
	$('body').on('click', '.tt-add-reseller-license', function (e) {
		e.preventDefault();

		ajax.ajaxCallDeferred('admin/project/resellers/create_voucher_code', 'GET', null, false)
			.done(function (data) {
				if (ajax.ajaxSucceeded(data)) {
					$('#m_voucher_code').val(data);
					$('#m_voucher_code').addClass('edited');
				}
			});
	});

	// Neue Lizenz kaufen - Gesamtpreis berechnen
	$('body').on('change', '.tt-amount-per-license,.tt-number-of-licenses', function (e) {
		e.preventDefault();

		var numberOfLicenses = $($(this).parents('.modal-body,.mt-list-item')[0]).find('.tt-number-of-licenses');
		var amountPerLicense = $($(this).parents('.modal-body,.mt-list-item')[0]).find('.tt-amount-per-license');
		var amount = $($(this).parents('.modal-body,.mt-list-item')[0]).find('.tt-amount');

		if ($(numberOfLicenses).val().length && $(amountPerLicense).val().length) {
			try {
				$(amount).val(utils.numberToString(utils.stringToNumber($(numberOfLicenses).val()) * utils.stringToNumber($(amountPerLicense).val()), 2));
				$(amount).addClass('edited');
			} catch (NaNError) {
				$(amount).val('');
				$(amount).removeClass('edited');
			}
		} else {
			$(amount).val('');
			$(amount).removeClass('edited');
		}
	});

	// Kalkulation anzeigen
	$('body').on('click', '.tt-calculation', function (e) {
		e.preventDefault();

		$('.tt-content').addClass('hide');
		$('.tt-content-calculation').removeClass('hide');
		utils.setPortletMaxHeight();

		utils.resetForm($('#portlet_calculation_section'));
		$('#table_calculations_detail_form').find('.tab-pane').removeClass('active');
		$('#table_calculations_detail_form').find('.nav-tabs li').removeClass('active');
		$('#tab_usage_data').addClass('active');
		$($('#table_calculations_detail_form').find('.nav-tabs li')[0]).addClass('active');

		var listItem = $($(this).parents('.mt-element-list').find('.mt-list-container .mt-list-item.active')[0]);
		$('#tab_name').val($(this).parents('.tab-pane')[0].id);

		if (listItem.find('[name^="amount_per_period_and_participant_"]').length && listItem.find('[name^="amount_per_period_and_participant_"]').val().length) {
			$('#c_amount_per_period_and_participant').val(listItem.find('[name^="amount_per_period_and_participant_"]').val());
			$('#c_amount_per_period_and_participant').addClass('edited');
		}
		if (listItem.find('[name^="once_only_amount_"]').val().length) {
			$('#c_once_only_amount').val(listItem.find('[name^="once_only_amount_"]').val());
			$('#c_once_only_amount').addClass('edited');
		}
		if (listItem.find('[name^="from_number_of_lanr_bsnr_"]').length && listItem.find('[name^="from_number_of_lanr_bsnr_"]').val().length) {
			$('#c_from_number_of_lanr_bsnr').val(listItem.find('[name^="from_number_of_lanr_bsnr_"]').val());
			$('#c_from_number_of_lanr_bsnr').addClass('edited');
		}
		if (listItem.find('[name^="lanr_bsnr_"]').length) {
			$('.tt-content-calculation').find('[name="lanr_bsnr"][value="' + listItem.find('[name^="lanr_bsnr_"]:checked').val() + '"]').prop('checked', true);
		}

		if (listItem.find('[name^="pvs_usage_"]').length && listItem.find('[name^="pvs_usage_"]').val().length) {
			$('#c_pvs_usage').select2().val(listItem.find('[name^="pvs_usage_"]').val().split('|')).trigger('change');
		}
		if (listItem.find('[name^="extraction_rate_"]').length && listItem.find('[name^="extraction_rate_"]').val().length) {
			$('#c_extraction_rate').select2().val(listItem.find('[name^="extraction_rate_"]').val()).trigger('change');
		}
		if (listItem.find('[name^="extraction_retrospective_"]').length && listItem.find('[name^="extraction_retrospective_"]').val().length) {
			$('#c_extraction_retrospective').select2().val(listItem.find('[name^="extraction_retrospective_"]').val()).trigger('change');
		}
		if (listItem.find('[name^="limited_use_"]').length && listItem.find('[name^="limited_use_"]').val().length) {
			$('#c_limited_use').select2().val(listItem.find('[name^="limited_use_"]').val()).trigger('change');
		}
		if (listItem.find('[name^="payment_on_use_"]').length && listItem.find('[name^="payment_on_use_"]').val().length) {
			if (listItem.find('[name^="payment_on_use_"]').val() === '1') {
				$('#c_payment_on_use').prop('checked', true);
			}
		}
		if (listItem.find('[name^="first_level_support_"]').length && listItem.find('[name^="first_level_support_"]').val().length) {
			if (listItem.find('[name^="first_level_support_"]').val() === '1') {
				$('#c_first_level_support').prop('checked', true);
			}
		}
		if (listItem.find('[name^="master_data_"]').val().length) {
			if (listItem.find('[name^="master_data_"]').val() === '1') {
				$('#c_master_data').prop('checked', true);
				$('#c_birth_date').removeAttr('disabled');
				$('#c_iv_data').removeAttr('disabled');
			} else {
				$('#c_birth_date').attr('disabled', 'disabled');
				$('#c_iv_data').attr('disabled', 'disabled');
			}
		}
		if (listItem.find('[name^="birth_date_"]').val().length) {
			if (listItem.find('[name^="birth_date_"]').val() === '1') {
				$('#c_birth_date').prop('checked', true);
			}
		}
		if (listItem.find('[name^="iv_data_"]').val().length) {
			if (listItem.find('[name^="iv_data_"]').val() === '1') {
				$('#c_iv_data').prop('checked', true);
			}
		}
		if (listItem.find('[name^="insurance_data_"]').val().length) {
			if (listItem.find('[name^="insurance_data_"]').val() === '1') {
				$('#c_insurance_data').prop('checked', true);
			}
		}
		if (listItem.find('[name^="clinical_master_data_"]').val().length) {
			if (listItem.find('[name^="clinical_master_data_"]').val() === '1') {
				$('#c_clinical_master_data').prop('checked', true);
			}
		}
		if (listItem.find('[name^="insurance_certificate_"]').val().length) {
			if (listItem.find('[name^="insurance_certificate_"]').val() === '1') {
				$('#c_insurance_certificate').prop('checked', true);
			}
		}
		if (listItem.find('[name^="private_certificate_"]').val().length) {
			if (listItem.find('[name^="private_certificate_"]').val() === '1') {
				$('#c_private_certificate').prop('checked', true);
			}
		}
		if (listItem.find('[name^="misc_certificate_"]').val().length) {
			if (listItem.find('[name^="misc_certificate_"]').val() === '1') {
				$('#c_misc_certificate').prop('checked', true);
			}
		}
		if (listItem.find('[name^="form_data_"]').val().length) {
			if (listItem.find('[name^="form_data_"]').val() === '1') {
				$('#c_form_data').prop('checked', true);
			}
		}
		if (listItem.find('[name^="permanent_diagnosis_"]').val().length) {
			if (listItem.find('[name^="permanent_diagnosis_"]').val() === '1') {
				$('#c_permanent_diagnosis').prop('checked', true);
			}
		}
		if (listItem.find('[name^="diagnosis_"]').val().length) {
			if (listItem.find('[name^="diagnosis_"]').val() === '1') {
				$('#c_diagnosis').prop('checked', true);
			}
		}
		if (listItem.find('[name^="prescription_medication_"]').val().length) {
			if (listItem.find('[name^="prescription_medication_"]').val() === '1') {
				$('#c_prescription_medication').prop('checked', true);
			}
		}
		if (listItem.find('[name^="prescription_adjuvant_"]').val().length) {
			if (listItem.find('[name^="prescription_adjuvant_"]').val() === '1') {
				$('#c_prescription_adjuvant').prop('checked', true);
			}
		}
		if (listItem.find('[name^="prescription_remedies_"]').val().length) {
			if (listItem.find('[name^="prescription_remedies_"]').val() === '1') {
				$('#c_prescription_remedies').prop('checked', true);
			}
		}
		if (listItem.find('[name^="permanent_medication_"]').val().length) {
			if (listItem.find('[name^="permanent_medication_"]').val() === '1') {
				$('#c_permanent_medication').prop('checked', true);
			}
		}
		if (listItem.find('[name^="medication_"]').val().length) {
			if (listItem.find('[name^="medication_"]').val() === '1') {
				$('#c_medication').prop('checked', true);
			}
		}
		if (listItem.find('[name^="medication_plan_"]').val().length) {
			if (listItem.find('[name^="medication_plan_"]').val() === '1') {
				$('#c_medication_plan').prop('checked', true);
			} else {
				$('#c_medication_plan').removeAttr('checked');
			}
		}
		if (listItem.find('[name^="medication_mapper_"]').val().length) {
			if (listItem.find('[name^="medication_mapper_"]').val() === '1') {
				$('#c_medication_mapper').prop('checked', true);
			}
		}
		if (listItem.find('[name^="lab_data_"]').val().length) {
			if (listItem.find('[name^="lab_data_"]').val() === '1') {
				$('#c_lab_data').prop('checked', true);
			}
		}
		if (listItem.find('[name^="clinical_course_data_"]').val().length) {
			if (listItem.find('[name^="clinical_course_data_"]').val() === '1') {
				$('#c_clinical_course_data').prop('checked', true);
			}
		}
		if (listItem.find('[name^="misc_data_"]').val().length) {
			if (listItem.find('[name^="misc_data_"]').val() === '1') {
				$('#c_misc_data').prop('checked', true);
			}
		}
		if (listItem.find('[name^="invoices_"]').val().length) {
			if (listItem.find('[name^="invoices_"]').val() === '1') {
				$('#c_invoices').prop('checked', true);
				$('#c_invoices_cancel_export').removeAttr('disabled');
			} else {
				$('#c_invoices_cancel_export').attr('disabled', 'disabled');
			}
		}
		if (listItem.find('[name^="invoices_cancel_export_"]').val().length) {
			if (listItem.find('[name^="invoices_cancel_export_"]').val() === '1') {
				$('#c_invoices_cancel_export').prop('checked', true);
			}
		}
		if (listItem.find('[name^="invoices_insurance_association_"]').val().length) {
			if (listItem.find('[name^="invoices_insurance_association_"]').val() === '1') {
				$('#c_invoices_insurance_association').prop('checked', true);
				$('#c_invoices_insurance_association_cancel_export').removeAttr('disabled');
			} else {
				$('#c_invoices_insurance_association_cancel_export').attr('disabled', 'disabled');
			}
		}
		if (listItem.find('[name^="invoices_insurance_association_cancel_export_"]').val().length) {
			if (listItem.find('[name^="invoices_insurance_association_cancel_export_"]').val() === '1') {
				$('#c_invoices_insurance_association_cancel_export').prop('checked', true);
			}
		}
		if (listItem.find('[name^="patient_contacts_"]').val().length) {
			if (listItem.find('[name^="patient_contacts_"]').val() === '1') {
				$('#c_patient_contacts').prop('checked', true);
				$('#c_documentation').removeAttr('disabled');
				$('#c_accounting').removeAttr('disabled');
				$('#c_patient_contact_dates').removeAttr('disabled');
				$('#c_count_patient_contacts').removeAttr('disabled');
			} else {
				$('#c_documentation').attr('disabled', 'disabled');
				$('#c_accounting').attr('disabled', 'disabled');
				$('#c_patient_contact_dates').attr('disabled', 'disabled');
				$('#c_count_patient_contacts').attr('disabled', 'disabled');
			}
		}
		if (listItem.find('[name^="patient_contact_collection_type_"]').val().length) {
			if (listItem.find('[name^="patient_contact_collection_type_"]').val() === 'documentation') {
				$('#c_documentation').prop('checked', true);
			} else if (listItem.find('[name^="patient_contact_collection_type_"]').val() === 'accounting') {
				$('#c_accounting').prop('checked', true);
			}
		}
		if (listItem.find('[name^="patient_contact_dates_"]').val().length) {
			if (listItem.find('[name^="patient_contact_dates_"]').val() === '1') {
				$('#c_patient_contact_dates').prop('checked', true);
			}
		}
		if (listItem.find('[name^="count_patient_contacts_"]').val().length) {
			if (listItem.find('[name^="count_patient_contacts_"]').val() === '1') {
				$('#c_count_patient_contacts').prop('checked', true);
			}
		}
		if (listItem.find('[name^="ims_data_"]').val().length) {
			if (listItem.find('[name^="ims_data_"]').val() === '1') {
				$('#c_ims_data').prop('checked', true);
			}
		}
	});

	$('body').on('change', '#c_patient_contacts', function (e) {
		e.preventDefault();

		if ($(this).is(':checked')) {
			$('#c_documentation').removeAttr('disabled');
			$('#c_accounting').removeAttr('disabled');
			$('#c_patient_contact_dates').removeAttr('disabled');
			$('#c_count_patient_contacts').removeAttr('disabled');
		} else {
			$('#c_documentation').attr('disabled', 'disabled');
			$('#c_accounting').attr('disabled', 'disabled');
			$('#c_patient_contact_dates').attr('disabled', 'disabled');
			$('#c_count_patient_contacts').attr('disabled', 'disabled');
			$('#c_documentation').prop('checked', false);
			$('#c_accounting').prop('checked', false);
			$('#c_patient_contact_dates').prop('checked', false);
			$('#c_count_patient_contacts').prop('checked', false);
		}
	});

	$('body').on('change', '#c_master_data', function (e) {
		e.preventDefault();

		if ($(this).is(':checked')) {
			$('#c_birth_date').removeAttr('disabled');
			$('#c_iv_data').removeAttr('disabled');
		} else {
			$('#c_birth_date').attr('disabled', 'disabled');
			$('#c_birth_date').prop('checked', false);
			$('#c_iv_data').attr('disabled', 'disabled');
			$('#c_iv_data').prop('checked', false);
		}
	});

	$('body').on('change', '#c_invoices', function (e) {
		e.preventDefault();

		if ($(this).is(':checked')) {
			$('#c_invoices_cancel_export').removeAttr('disabled');
		} else {
			$('#c_invoices_cancel_export').attr('disabled', 'disabled');
			$('#c_invoices_cancel_export').prop('checked', false);
		}
	});

	$('body').on('change', '#c_invoices_insurance_association', function (e) {
		e.preventDefault();

		if ($(this).is(':checked')) {
			$('#c_invoices_insurance_association_cancel_export').removeAttr('disabled');
		} else {
			$('#c_invoices_insurance_association_cancel_export').attr('disabled', 'disabled');
			$('#c_invoices_insurance_association_cancel_export').prop('checked', false);
		}
	});

	// Listeneintrag kopieren
	$('body').on('click', '.tt-copy-list-item', function (e) {
		e.preventDefault();

		var formId = $(this).data().formId;
		var listItem = $($(this).parents('.mt-element-list').find('.mt-list-container .mt-list-item.active')[0]);

		if (listItem.find('[name^="lanr_bsnr_"]').length) {
			$('#' + formId).find('[name="lanr_bsnr"][value="' + listItem.find('[name^="lanr_bsnr_"]:checked').val() + '"]').prop('checked', true);
		}
		if (listItem.find('[name^="professional_groups_only_once_"]').length) {
			if (listItem.find('[name^="professional_groups_only_once_"]').is(':checked')) {
				$('#' + formId).find('[name="professional_groups_only_once"]').prop('checked', true);
			}
		}
		if (listItem.find('[name^="from_number_of_lanr_bsnr_"]').length) {
			$('#' + formId).find('[name="from_number_of_lanr_bsnr"]').val(listItem.find('[name^="from_number_of_lanr_bsnr_"]').val());
		}
		if (listItem.find('[name^="amount_per_period_and_participant_"]').length) {
			$('#' + formId).find('[name="amount_per_period_and_participant"]').val(listItem.find('[name^="amount_per_period_and_participant_"]').val());
		}
		if (listItem.find('[name^="once_only_amount_"]').length) {
			$('#' + formId).find('[name="once_only_amount"]').val(listItem.find('[name^="once_only_amount_"]').val());
		}
		if (listItem.find('[name^="valid_from_"]').length) {
			$('#' + formId).find('[name="valid_from"]').data('picker').setDate(listItem.find('[name^="valid_from"]').data('picker').getDate());
		}

		var fieldArray = ['pvs_usage', 'extraction_rate', 'extraction_retrospective', 'limited_use', 'payment_on_use', 'first_level_support', 'master_data', 'insurance_data', 'clinical_master_data', 'insurance_certificate', 'private_certificate', 'misc_certificate', 'form_data', 'permanent_diagnosis', 'diagnosis', 'prescription_medication', 'prescription_adjuvant', 'prescription_remedies', 'permanent_medication', 'medication', 'medication_plan', 'medication_mapper', 'lab_data', 'clinical_course_data', 'misc_data', 'patient_contacts', 'ims_data', 'invoices', 'invoices_insurance_association', 'invoices_cancel_export', 'invoices_insurance_association_cancel_export'];
		$.each(fieldArray, function (i, field) {
			if (listItem.find('[name^="' + field + '_"]').length) {
				$('#' + formId).find('[name="' + field + '"]').val(listItem.find('[name^="' + field + '_"]').val());
			}
		});

		$('#' + formId).submit();
	});

	// XSD / Basislizenz / Lizenz erstellen
	$('body').on('click', '.tt-create-xsd,.tt-create-base-license,.tt-create-license', function (e) {
		e.preventDefault();

		var element = $(this);

		validator.getFormData($('#table_licenses_form')).done(function (data) {
			data = data.replace('_method=PUT&', '');
			ajax.ajaxCall(element.attr('href'), element.attr('method'), data, false, function (data) {

				window.open(data, '_blank');

				setTimeout(function () {
					// Ordner mit Dateien auf PUBLIC wieder löschen
					ajax.ajaxCall(data + '/delete', "POST", null, false, function (data) {
					});

				}, 1000);
			});
		});
	});

	// Anzeige des Fehlerprotokolls bzw. des Exportberichts
	$('body').on('click', '.tt-show-error-report,.tt-show-export-report', function (e) {
		e.preventDefault();

		$($(this).parents('.form-group').find('.cbp-item:last-child')).find('a').click();
	});

	// Fehlerprotokoll - Wechsel zwischen globalem und connectPVS Protokoll
	$('body').on('click', '.tt-switch-reports', function (e) {
		e.preventDefault();

		if ($(this).data().reportType === 'error_report') {
			$('.tt-error-report').addClass('display-none');
			$('.tt-error-report-global').removeClass('display-none');
			$(this).text(trans('extrax2-webadmin.show_error_report'));
			$('.cbp-l-project-title').text(trans('extrax2-webadmin.error_report_global'));
			$(this).data('report-type', 'error_report_global');
		} else {
			$('.tt-error-report').removeClass('display-none');
			$('.tt-error-report-global').addClass('display-none');
			$(this).text(trans('extrax2-webadmin.show_error_report_global'));
			$('.cbp-l-project-title').text(trans('extrax2-webadmin.error_report'));
			$(this).data('report-type', 'error_report');
		}
	});

	$('body').on('click', '.tt-set-project-next-export-to-initial-export', function (e) {
		e.preventDefault();

		let self = $(this);
		ajax.ajaxCall('admin/project/' + $('[name="project_id"]').val() + '/participants/' + 0 + '/set_initial_export/' + true,'POST',null,false,function (data) {
		});
	});

	$('body').on('click', '.tt-set-participant-next-export-to-initial-export', function (e) {
		e.preventDefault();

		let self = $(this);
		ajax.ajaxCall('admin/project/' + $('[name="project_id"]').val() + '/participants/' + $('[name="participant_id"]').val() + '/set_initial_export/' + true,'POST',null,false,function (data) {
			self.addClass('disabled');
			$("#next_export_is_initial_export_info").removeAttr('hidden');
		});
	});

   $('body').on('click', '.tt-set-participant-do-export-immediately', function (e) {
      e.preventDefault();

      let self = $(this);
      ajax.ajaxCall('admin/project/' + $('[name="project_id"]').val() + '/participants/' + $('[name="participant_id"]').val() + '/do_export_immediately/' + true,'POST',null,false,function (data) {
         self.addClass('disabled');
         $("#do_export_immediately").removeAttr('hidden');
      });
   });

	// Zum Teilnehmer springen (aus fehlgeschlagener Übertragung)
	$('body').on('click', '.tt-participant', function (e) {
		e.preventDefault();

		utils.updateGlobals('participantToShow', $(this).data().participantId);

		ajax.ajaxCall($(this).data().href, 'GET', 'failed_request=' + $('#support_id').val(), true, function (data) {
			utils.setHtmlData($("#content"), data, true);
		});
	});

	// Zurück zur fehlgeschlagenen Übertragung aus dem Teilnehmer
	$('body').on('click', '.tt-back-to-failed-request', function (e) {
		e.preventDefault();

		var failedRequestId = $(this).data().failedRequest;

		ajax.ajaxCall($(this).attr('action'), $(this).attr('method'), null, true, function (data) {
			utils.setHtmlData($("#content"), data, true);

			$('#support_id').val(failedRequestId);
			$('#table_failed_requests_form').submit();
		});
	});

	// Ausgeführte Aktion für fehlgeschlagener Übertragung beim Teilnehmer speichern
	$('body').on('click', '.tt-ignore-last-request-error,.tt-add-serial-number,.tt-delete-last-request', function (e) {
		e.preventDefault();

		var messageText = '';
		if ($(this).hasClass('tt-ignore-last-request-error')) {
			messageText = Lang.get('extrax2-webadmin.last_request_error_ignored');
		} else if ($(this).hasClass('tt-add-serial-number')) {
			messageText = Lang.get('extrax2-webadmin.serial_number_added');
		} else if ($(this).hasClass('tt-delete-last-request')) {
			messageText = Lang.get('extrax2-webadmin.last_request_deleted');
		}

		ajax.ajaxCall($(this).attr('action'), $(this).attr('method'), null, true, function (data) {

			bootbox.dialog({
				message: messageText,
				title: Lang.get('extrax2-webadmin.failed_request'),
				buttons: {
					ok: {
						label: Lang.get('extrax2-webadmin.ok'),
						className: "btn blue bootbox-btn",
						callback: function () {
						}
					}
				}
			});
			utils.setHtmlData($("#content"), data, true);
		});
	});

	// Kündigungswirksamkeit berechnen
	$('body').on('change', '#notice_date,#reference_date', function (e) {
		e.preventDefault();

		if (!utils.GLOBALS.programmaticChange && !utils.isUndefined($('#notice_date').data('picker'))) {
			var noticeDate = $('#notice_date').data('picker').getDate();
			if (utils.isUndefined(noticeDate)) {
				$('#validity_date').data('picker').setDate(null);
				$('#validity_date').removeClass('edited');

				$('#last_export_date').data('picker').setDate(null);
				$('#last_export_date').removeClass('edited');
			} else {
				var referenceDate = $('#reference_date').select2().val();
				var startDate = $('#start_date').data('picker').getDate();
				if (!utils.isUndefined(startDate)) {
					startDate = moment(startDate);
					var validityDate = moment(startDate).add(parseInt($('#minimum_duration').val()), 'months').subtract(1, 'days');
					if (referenceDate === 'end_of_month') {
						validityDate = validityDate.endOf('month');
					} else if (referenceDate === 'end_of_quarter') {
						validityDate = validityDate.endOf('quarter');
					} else if (referenceDate === 'end_of_half_year') {
						validityDate = validityDate.endOf('quarter');
						if (validityDate.month() !== 6 && validityDate.month() !== 12) {
							validityDate = validityDate.add(1, 'days').endOf('quarter');
						}
					} else if (referenceDate === 'end_of_year') {
						validityDate = validityDate.endOf('year');
					}
					// console.log(validityDate.format('DD.MM.YYYY'));
					while (moment(validityDate).subtract(parseInt($('#notice').val()), $('#notice_time_unit').val()) < noticeDate) {
						if (referenceDate !== '' && referenceDate !== 'no_reference_date') {

							if (referenceDate === 'end_of_month') {
								validityDate = validityDate.add(1, 'months');
								validityDate = validityDate.endOf('month');
							} else if (referenceDate === 'end_of_quarter') {
								validityDate = validityDate.add(1, 'quarters');
								validityDate = validityDate.endOf('quarter');
							} else if (referenceDate === 'end_of_half_year') {
								validityDate = validityDate.add(2, 'quarters');
								validityDate = validityDate.endOf('quarter');
							} else if (referenceDate === 'end_of_year') {
								validityDate = validityDate.add(1, 'years');
								validityDate = validityDate.endOf('year');
							}

						} else {
							validityDate = validityDate.add(parseInt($('#duration').val()), 'months');
							validityDate = validityDate.endOf('month');
						}
						// console.log('------');
						// console.log(validityDate.format('DD.MM.YYYY'));
					}

					$('#validity_date').data('picker').setDate(validityDate.toDate());
					$('#validity_date').addClass('edited');

					$('#last_export_date').data('picker').setDate(validityDate.toDate());
					$('#last_export_date').addClass('edited');

				}
			}
		}
	});

	// Kündigungswirksamkeit darf nicht älter sein als das Ende des letzten abgerechneten Zeitraums
	$('body').on('change', '#validity_date', function (e) {
		e.preventDefault();

		// var validityDate = $('#validity_date').data('picker').getDate();
		// var minValidityDate = $('#validity_date').data('minValidityDate');
		// if (!utils.isUndefined(validityDate) && !utils.isUndefined(minValidityDate) && minValidityDate !== '') {
		// 	if (validityDate < utils.stringToDate(minValidityDate)) {
		// 		bootbox.dialog({
		// 			message: Lang.get('extrax2-webadmin.warning_validity_date', {'minValidityDate': utils.dateToLocaleString(minValidityDate)}),
		// 			title: Lang.get('extrax2-webadmin.title_warning_validity_date'),
		// 			buttons: {
		// 				ok: {
		// 					label: Lang.get('extrax2-webadmin.ok'),
		// 					className: "btn blue bootbox-btn",
		// 					callback: function () {
		// 						$('#validity_date').data('picker').setDate(utils.stringToDate(minValidityDate));
		// 						$('#last_export_date').data('picker').setDate(utils.stringToDate(minValidityDate));
		// 					}
		// 				}
		// 			}
		// 		});
		// 	}
		// }
	});

	// Bei patax plus Projekten 'pauschale Abrechnung' und 'Vorige Teilnehemer-ID Suche' abhaken
	$('body').on('change', '[name="project_type"],[name="fixed_accounting"],[name="scale_pricing_for_all_payer"]', function (e) {
		e.preventDefault();

		if (this.checked) {
			if (this.name === 'project_type' && ($(this).val() === 'patax' || $(this).val() === 'patax-plus-server')) {
				$('[name="fixed_accounting"]').removeAttr('checked');
				$('.tt-assigned-patax-project').addClass('hide');
				$('[name="assigned_patax_project"]').val(null).trigger('change');
			} else if (this.name === 'project_type' && ($(this).val() === 'extrax' || $(this).val() === 'tripletrax')) {
				$('.tt-assigned-patax-project').removeClass('hide');
			} else if (this.name === 'scale_pricing_for_all_payer') {
				$('[name="fixed_accounting"]').removeAttr('checked');
			} else if (this.name === 'fixed_accounting') {
				$('[name="scale_pricing_for_all_payer"]').removeAttr('checked');
				$('[name="project_type"][value="extrax"]').prop('checked', true);
			}
		}
	});

	// Bei Angabe Anonymisierung in Lizenz zugehörige Felder en-/disablen
	$('body').on('change', '[name="anonym"]', function (e) {
		e.preventDefault();

		if ($(this).select2().val() === 'plain') {
			$('select[name="pseudonym_type"]').val(null).trigger('change');
			$('[name="pseudonym_type"]').addClass('disabled');
			$('[name="pseudonym_type"]').attr('disabled', 'disabled');
			$('[name="freetext_exclusion"]').removeAttr('checked');
			$('[name="freetext_exclusion"]').addClass('disabled');
			$('[name="freetext_exclusion"]').attr('disabled', 'disabled');
			$('[name="postal_code_inclusion"]').removeAttr('checked');
			$('[name="postal_code_inclusion"]').addClass('disabled');
			$('[name="postal_code_inclusion"]').attr('disabled', 'disabled');
			$('[name="country_exclusion"]').removeAttr('checked');
			$('[name="country_exclusion"]').addClass('disabled');
			$('[name="country_exclusion"]').attr('disabled', 'disabled');
			$('[name="birth_date_only_year"]').removeAttr('checked');
			$('[name="birth_date_only_year"]').addClass('disabled');
			$('[name="birth_date_only_year"]').attr('disabled', 'disabled');
			$('[name="write_pseudonym_patient_list"]').removeAttr('checked');
			$('[name="write_pseudonym_patient_list"]').addClass('disabled');
			$('[name="write_pseudonym_patient_list"]').attr('disabled', 'disabled');
			$('[name="use_pseudonym_patient_list"]').removeAttr('checked');
			$('[name="use_pseudonym_patient_list"]').addClass('disabled');
			$('[name="use_pseudonym_patient_list"]').attr('disabled', 'disabled');
		} else if ($(this).select2().val() === 'anonym') {
			$('[name="pseudonym_type"]').val(null).trigger('change');
			$('[name="pseudonym_type"]').addClass('disabled');
			$('[name="pseudonym_type"]').attr('disabled', 'disabled');
			$('[name="freetext_exclusion"]').removeClass('disabled');
			$('[name="freetext_exclusion"]').removeAttr('disabled');
			$('[name="postal_code_inclusion"]').removeClass('disabled');
			$('[name="postal_code_inclusion"]').removeAttr('disabled');
			$('[name="country_exclusion"]').removeClass('disabled');
			$('[name="country_exclusion"]').removeAttr('disabled');
			$('[name="birth_date_only_year"]').removeClass('disabled');
			$('[name="birth_date_only_year"]').removeAttr('disabled');
			$('[name="write_pseudonym_patient_list"]').removeClass('disabled');
			$('[name="write_pseudonym_patient_list"]').removeAttr('disabled');
			$('[name="use_pseudonym_patient_list"]').removeClass('disabled');
			$('[name="use_pseudonym_patient_list"]').removeAttr('disabled');
		} else if ($(this).select2().val() === 'pseudonym') {
			$('[name="pseudonym_type"]').removeClass('disabled');
			$('[name="pseudonym_type"]').removeAttr('disabled');
			$('[name="freetext_exclusion"]').removeClass('disabled');
			$('[name="freetext_exclusion"]').removeAttr('disabled');
			$('[name="postal_code_inclusion"]').removeClass('disabled');
			$('[name="postal_code_inclusion"]').removeAttr('disabled');
			$('[name="country_exclusion"]').removeClass('disabled');
			$('[name="country_exclusion"]').removeAttr('disabled');
			$('[name="birth_date_only_year"]').removeClass('disabled');
			$('[name="birth_date_only_year"]').removeAttr('disabled');
			$('[name="write_pseudonym_patient_list"]').removeClass('disabled');
			$('[name="write_pseudonym_patient_list"]').removeAttr('disabled');
			$('[name="use_pseudonym_patient_list"]').removeClass('disabled');
			$('[name="use_pseudonym_patient_list"]').removeAttr('disabled');
		}
	});

	// Bei Angabe BSNR exportieren in Lizenz zugehörige Felder en-/disablen
	$('body').on('change', '[name="export_bsnr"]', function (e) {
		e.preventDefault();

		if (this.checked) {
			$('[name="export_bsnr_hashed"]').removeClass('disabled');
			$('[name="export_bsnr_hashed"]').removeAttr('disabled');
		} else {
			$('[name="export_bsnr_hashed"]').removeAttr('checked');
			$('[name="export_bsnr_hashed"]').addClass('disabled');
			$('[name="export_bsnr_hashed"]').attr('disabled', 'disabled');
			$('[name="export_bsnr_hash_salt"]').val('');
			$('[name="export_bsnr_hash_salt"]').addClass('disabled');
			$('[name="export_bsnr_hash_salt"]').attr('disabled', 'disabled');
		}
	});

	// Bei Angabe BSNR exportieren in Lizenz zugehörige Felder en-/disablen
	$('body').on('change', '[name="export_bsnr_hashed"]', function (e) {
		e.preventDefault();

		if (this.checked) {
			$('[name="export_bsnr_hash_salt"]').removeClass('disabled');
			$('[name="export_bsnr_hash_salt"]').removeAttr('disabled');
		} else {
			$('[name="export_bsnr_hash_salt"]').val('');
			$('[name="export_bsnr_hash_salt"]').addClass('disabled');
			$('[name="export_bsnr_hash_salt"]').attr('disabled', 'disabled');
		}
	});

	// Bei Angabe LANR exportieren in Lizenz zugehörige Felder en-/disablen
	$('body').on('change', '[name="export_lanr"]', function (e) {
		e.preventDefault();

		if (this.checked) {
			$('[name="export_lanr_hashed"]').removeClass('disabled');
			$('[name="export_lanr_hashed"]').removeAttr('disabled');
		} else {
			$('[name="export_lanr_hashed"]').removeAttr('checked');
			$('[name="export_lanr_hashed"]').addClass('disabled');
			$('[name="export_lanr_hashed"]').attr('disabled', 'disabled');
			$('[name="export_lanr_hash_salt"]').val('');
			$('[name="export_lanr_hash_salt"]').addClass('disabled');
			$('[name="export_lanr_hash_salt"]').attr('disabled', 'disabled');
		}
	});

	// Bei Angabe LANR exportieren in Lizenz zugehörige Felder en-/disablen
	$('body').on('change', '[name="export_lanr_hashed"]', function (e) {
		e.preventDefault();

		if (this.checked) {
			$('[name="export_lanr_hash_salt"]').removeClass('disabled');
			$('[name="export_lanr_hash_salt"]').removeAttr('disabled');
		} else {
			$('[name="export_lanr_hash_salt"]').val('');
			$('[name="export_lanr_hash_salt"]').addClass('disabled');
			$('[name="export_lanr_hash_salt"]').attr('disabled', 'disabled');
		}
	});


	// Bei Angabe Benutzer exportieren in Lizenz zugehörige Felder en-/disablen
	$('body').on('change', '[name="export_user"]', function (e) {
		e.preventDefault();

		if (this.checked) {
			$('[name="export_user_hashed"]').removeClass('disabled');
			$('[name="export_user_hashed"]').removeAttr('disabled');
		} else {
			$('[name="export_user_hashed"]').removeAttr('checked');
			$('[name="export_user_hashed"]').addClass('disabled');
			$('[name="export_user_hashed"]').attr('disabled', 'disabled');
			$('[name="export_user_hash_salt"]').val('');
			$('[name="export_user_hash_salt"]').addClass('disabled');
			$('[name="export_user_hash_salt"]').attr('disabled', 'disabled');
		}
	});

	// Bei Angabe Benutzer exportieren in Lizenz zugehörige Felder en-/disablen
	$('body').on('change', '[name="export_user_hashed"]', function (e) {
		e.preventDefault();

		if (this.checked) {
			$('[name="export_user_hash_salt"]').removeClass('disabled');
			$('[name="export_user_hash_salt"]').removeAttr('disabled');
		} else {
			$('[name="export_user_hash_salt"]').val('');
			$('[name="export_user_hash_salt"]').addClass('disabled');
			$('[name="export_user_hash_salt"]').attr('disabled', 'disabled');
		}
	});

	// Vertragsdaten des zu übernehmenden Teilnehmer anzeigen
	$('body').on('change', '#assign_contract_from', function (e) {
		e.preventDefault();
		if ($(this).select2().val() === '') {
			$('#lanr_bsnr_content_detail').empty();
		} else {
			ajax.ajaxCall($(this).data().dataUrl + $(this).select2().val() + '/contracts', 'GET', null, false, function (data) {
				utils.setHtmlData($('#lanr_bsnr_content_detail'), data, true);
			});
		}
	});

	// Abrechnung - nur fehlerhafte anzeigen
	$('body').on('change', '#show_all_with_errors', function (e) {
		e.preventDefault();

		if ($(this).is(':checked')) {
			$('#table_account_draw_up').dataTable().api().columns(12).search(true).draw();
		} else {
			$('#table_account_draw_up').dataTable().api().columns(12).search('').draw();
		}
	});

	// Zur nächsten Abrechnung gehen
	$('body').on('click', '.tt-draw-up-account-next', function (e) {
		e.preventDefault();
		let projectName = $(this).data('projectName');
		let element = $('[data-nav-item="account_draw_up_' + projectName + '"]');

		$('#project_menu_item').text(' ' + $(element).data('projectName'));
		$('#sub_menu_item').text(' ' + $(element).data('subMenuName'));
		$('#sub_menu_item').parent().removeClass('hide');
		$('#sub_menu_item').prepend('<i class="fa fa-lg fa-angle-right"></i>');
		$('#selected_menu_item').text(' ' + $(element).text());
		$('#selected_menu_item').parent().removeClass('hide');
		$('#selected_menu_item').prepend('<i class="fa fa-lg fa-angle-right"></i>');

		if ($(element).parents('.menu-dropdown-project').length) {
			$('#sub_menu_item').parent().find('.dropdown-menu').remove();
			$($(element).parents('.dropdown-menu')[1]).clone().appendTo($('#sub_menu_item').parent());
		}
		if ($(element).parents('.menu-dropdown-project').length || $(element).parents('.menu-dropdown-sub').length) {
			$('#selected_menu_item').parent().find('.dropdown-menu').remove();
			$($(element).parents('.dropdown-menu')[0]).clone().appendTo($('#selected_menu_item').parent());
		}
		$('#project_menu_item').prepend('<i class="icon-puzzle"></i>');
		$('#project_menu_item').append('<span class="arrow"></span>');

		ajax.ajaxCall($(this).attr('action'), 'GET', null, true, function (data) {

			utils.setHtmlData($("#content"), data, true);
		});
	});

	// Abrechnung durchführen
	$('body').on('click', '.tt-draw-up-account', function (e) {
		e.preventDefault();

		var element = $(this);
		var data = $('#table_account_draw_up').dataTable().api().data();
		var tableData = [];

		var showWarning = false;
		$.each(data, function (index, row) {
			if (row['error']) {
				showWarning = true;
			}
			tableData.push(row);
		});

		if (showWarning) {
			bootbox.dialog({
				message: Lang.get('extrax2-webadmin.warning_account_draw_up_errors'),
				title: Lang.get('extrax2-webadmin.title_warning_account_draw_up_errors'),
				buttons: {
					yes: {
						label: Lang.get('extrax2-webadmin.yes'),
						className: "btn btn-success bootbox-btn",
						callback: function () {
							drawUpAccount(element, tableData);
						}
					},
					cancel: {
						label: Lang.get('extrax2-webadmin.cancel'),
						className: "btn btn-danger bootbox-btn",
						callback: function () {
						}
					}
				}
			});
		} else {
			drawUpAccount(element, tableData);
		}
	});

	// abrechnungsrelevante Berichtsdaten exportieren
	$('body').on('click', '.tt-export-accounting-data', function (e) {
		e.preventDefault();

		var element = $(this);
		var data = $('#table_account_draw_up').dataTable().api().data();
		var tableData = [];

		$.each(data, function (index, row) {
			tableData.push(row);
		});

		exportAccountDataToExcel($(this).attr('action'), tableData);
	});

	// Abrechnung - Historie anzeigen / Zurück zur Abrechnung / Zurück zur Historie
	$('body').on('click', '.tt-show-history,.tt-back-to-draw-up-account,.tt-back-to-history', function (e) {
		e.preventDefault();

		ajax.ajaxCall($(this).attr('action'), $(this).attr('method'), null, false, function (data) {

			utils.setHtmlData($("#content"), data, true);
		});
	});

	// Abrechnung - In eine XML Datei exportieren / Nach Excel exportieren
	$('body').on('click', '.tt-export-to-excel', function (e) {
		e.preventDefault();

		var data = $('#table_account_draw_up').dataTable().api().data();
		var tableData = [];

		$.each(data, function (index, row) {
			if (row.selection) {
				tableData.push(row);
			}
		});

		exportAccountDataToExcel($(this).attr('action'), tableData);
	});

	// Prüfen, ob Vertrag Einmalnutzung beinhaltet
	$('body').on('change', '[name="start_date"],[name="invoice_recipient"]', function (e) {
		e.preventDefault();

		if (!utils.GLOBALS.programmaticChange && !$(this).parents('#table_project_partners_form').length) {
			var startDate = jQuery($('[name="start_date"]')).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '');
			if (startDate !== '') {
				var picker = $('[name="start_date"]').data('picker');
				startDate = utils.dateToString(picker.getDate());
			}
			var resellerId = '0';
			var invoiceRecipient = '';
			invoiceRecipient = $('[name="invoice_recipient"]').select2().val();
			if (/^reseller_/.test(invoiceRecipient)) {
				resellerId = invoiceRecipient.split('_')[1];
				invoiceRecipient = invoiceRecipient.split('_')[0];
			}
			var useDefaultAccountSettings = $('[name="use_default_account_settings"]')[0].checked;
			var chargingBy = $('[name="charging_by"]:checked').val();

			validator.checkForOneTimeUsage(useDefaultAccountSettings, invoiceRecipient, startDate, chargingBy, resellerId)
				.done(function (isOneTimeUsage) {
					if (isOneTimeUsage) {
						$('[name="contract_date"]').data('picker').setDate(null);
						$('[name="minimum_duration"]').val('');
						$('[name="duration"]').val('');
						$('[name="accounting_period"]').val('');
						$('[name="maturity"]').val(null).trigger('change');
						$('[name="reference_date"]').val(null).trigger('change');
						$('[name="notice"]').val('');
						$('[name="notice_time_unit"]').val('');
						$('[name="notice_date"]').data('picker').setDate(null);
						$('[name="validity_date"]').data('picker').setDate(null);
						$('[name="last_export_date"]').data('picker').setDate(null);
					}
				});
		}
	});

	// Einmalnutzung und Zahlung bei Nutzung schließen sich aus
	$('body').on('change', '[name="extraction_rate"],[name="payment_on_use"]', function (e) {
		e.preventDefault();

		if (this.name === 'extraction_rate' && ($(this).select2().val() === 'one_time' || $(this).select2().val() === 'one_time_migration')) {
			$('[name="payment_on_use"]').removeAttr('checked');
		} else if (this.name === 'payment_on_use' && this.checked && ($('select[name="extraction_rate"]').select2().val() === 'one_time' || $('select[name="extraction_rate"]').select2().val() === 'one_time_migration')) {
			$('select[name="extraction_rate"]').val(null).trigger('change');
		}
	});

	// Zeitplan - täglich, wöchentlich, monatlich ein- ausblenden
	$('body').on('change', '[name="schedule_type"]', function (e) {
		e.preventDefault();

		if ($('[name="schedule_type"]:checked').val() === 'daily') {
			$(this).parents('form').find('.tt-schedule-daily').removeClass('hide');
			$(this).parents('form').find('.tt-schedule-weekly').addClass('hide');
			$(this).parents('form').find('[name="repeat_all_x_weeks"]').val('');
			$(this).parents('form').find('[name="selection_days"]').val(null).trigger('change');

			$(this).parents('form').find('.tt-schedule-monthly').addClass('hide');
			$(this).parents('form').find('[name="selection_months"]').val(null).trigger('change');
			$(this).parents('form').find('[name="repeat_monthly_on_day"]').val(null).trigger('change');
			$(this).parents('form').find('[name="repeat_monthly"]').val(null).trigger('change');
			$(this).parents('form').find('[name="repeat_monthly_on_day_of_the_week"]').val(null).trigger('change');
		} else if ($('[name="schedule_type"]:checked').val() === 'weekly') {
			$(this).parents('form').find('.tt-schedule-daily').addClass('hide');
			$(this).parents('form').find('[name="repeat_all_x_days"]').val('');

			$(this).parents('form').find('.tt-schedule-weekly').removeClass('hide');
			$(this).parents('form').find('.tt-schedule-monthly').addClass('hide');
			$(this).parents('form').find('[name="selection_months"]').val(null).trigger('change');
			$(this).parents('form').find('[name="repeat_monthly_on_day"]').val(null).trigger('change');
			$(this).parents('form').find('[name="repeat_monthly"]').val(null).trigger('change');
			$(this).parents('form').find('[name="repeat_monthly_on_day_of_the_week"]').val(null).trigger('change');
		} else {
			$(this).parents('form').find('.tt-schedule-daily').addClass('hide');
			$(this).parents('form').find('[name="repeat_all_x_days"]').val('');

			$(this).parents('form').find('.tt-schedule-weekly').addClass('hide');
			$(this).parents('form').find('[name="repeat_all_x_weeks"]').val('');
			$(this).parents('form').find('[name="selection_days"]').val(null).trigger('change');

			$(this).parents('form').find('.tt-schedule-monthly').removeClass('hide');
		}
	});

	// Zeitplan monatlich - entweder am x-ten Tag oder am x-ten Wochentag des Monats
	$('body').on('change', '[name="repeat_monthly_on_day"],[name="repeat_monthly"],[name="repeat_monthly_on_day_of_the_week"]', function (e) {
		e.preventDefault();

		var value = $(this).select2().val();
		if (this.name === 'repeat_monthly_on_day' && value !== '') {
			$(this).parents('form').find('[name="repeat_monthly"]').val(null).trigger('change');
			$(this).parents('form').find('[name="repeat_monthly_on_day_of_the_week"]').val(null).trigger('change');
		} else if ((this.name === 'repeat_monthly' || this.name === 'repeat_monthly_on_day_of_the_week') && value !== '') {
			$(this).parents('form').find('[name="repeat_monthly_on_day"]').val(null).trigger('change');
		}
	});

	// Zeitplan monatlich - entweder am x-ten Tag oder am x-ten Wochentag des Monats
	$('body').on('change', '[name="external_recipient"],[name="external_recipient_is_participant"]', function (e) {
		e.preventDefault();

		if (this.name === 'external_recipient_is_participant' && $(this).is(':checked')) {
			$(this).parents('form').find('[name="external_recipient"]').val('');
		} else if (this.name === 'external_recipient' && $(this).val() !== '') {
			$(this).parents('form').find('[name="external_recipient_is_participant"]').prop('checked', false);
		}
	});

	// Interner Benutzer - entweder Auswahl Benutzer oder Angabe E-Mail
	$('body').on('change', '[name="user_id"],[name="internal_recipient"]', function (e) {
		e.preventDefault();

		if (this.name === 'user_id' && $(this).select2().val() !== '') {
			$(this).parents('form').find('[name="internal_recipient"]').val('');
		} else if (this.name === 'internal_recipient' && $(this).val() !== '') {
			$(this).parents('form').find('[name="user_id"]').val(null).trigger('change');
		}
	});

	// Anzeige von Mindestabnahmemenge bei den Abrechnungsparametern, wenn bei Rechnungsfälligkeit 'Zu Beginn der nächsten Periode' ausgewählt ist
	$('body').on('change', '.tt-account-maturity', function (e) {
		e.preventDefault();

		if ($(this).select2().val() === 'at_beginning_next_period') {
			$('.tt-minimum-payment').removeClass('hide');
		} else {
			$('.tt-minimum-payment').addClass('hide');
			$('#minimum_payment_bsnr').val('');
			$('#minimum_payment_lanr').val('');
			$('#minimum_payment_account_id').val('');
		}
	});

	// Teilnehmer sperren
	$('body').on('click', '.tt-lock-participant', function (e) {
		e.preventDefault();

		var element = $(this);

		ajax.ajaxCall($(this).attr('href'), $(this).attr('method'), null, false, function (data) {
			if (data === 'MAX_NUMBER_EXCEEDED') {
				bootbox.dialog({
					message: Lang.get('extrax2-webadmin.max_number_participants_exceeded_locked'),
					title: Lang.get('extrax2-webadmin.set_participant_active'),
					buttons: {
						ok: {
							label: Lang.get('extrax2-webadmin.ok'),
							className: "btn blue",
							callback: function () {
							}
						}
					}
				});
			} else {
				$('#content').find('.tt-content-datatable').find('.tt-datatable').dataTable().fnStandingRedraw();
				utils.setHtmlData($("#content-detail"), data, true);
			}
		});
	});

	// Teilnehmer hinzufügen - Prüfung auf maximale Teilnehmerzahl
	$('body').on('click', '.tt-add-participant', function (e) {
		e.preventDefault();

		var element = $(this);

		ajax.ajaxCall($(this).attr('action'), $(this).attr('method'), null, false, function (data) {
			if (data === 'MAX_NUMBER_EXCEEDED') {
				bootbox.dialog({
					message: Lang.get('extrax2-webadmin.max_number_participants_exceeded_add'),
					title: Lang.get('extrax2-webadmin.add_participant'),
					buttons: {
						ok: {
							label: Lang.get('extrax2-webadmin.ok'),
							className: "btn blue",
							callback: function () {
							}
						}
					}
				});
			} else {
				$('.tt-open-add-participant-dialog').click();
			}
		});
	});

	// BSNR/LANR hinzufügen - Prüfung ob Abrechnungsparameter gesetzt sind
	$('body').on('click', '.tt-add-bsnr-lanr', function (e) {
		e.preventDefault();

		if ($(this).data().accountSettingsSet) {
			$('.tt-open-add-bsnr-lanr-dialog').click();
		} else {
			bootbox.dialog({
				message: Lang.get('extrax2-webadmin.account_settings_are_not_set'),
				title: Lang.get('extrax2-webadmin.add_bsnr_lanr'),
				buttons: {
					ok: {
						label: Lang.get('extrax2-webadmin.ok'),
						className: "btn blue",
						callback: function () {
						}
					}
				}
			});
		}
	});

	// Statusreport drucken
	$('body').on('click', '.tt-print-status-report', function (e) {
		e.preventDefault();

		var element = $(this);

		window.open($(this).attr('action'), '_blank');
	});

	// Bei Empfängerliste E-Mail andere Felder zurücksetzen wenn E-Mail ausgewöhlt wurde
	$('body').on('change', '.tt-email-recipient-email', function (e) {
		e.preventDefault();

		if ($(this).val() !== '') {
			$(this).parents('form').find('.tt-email-recipient-project-partner').prop('checked', false);
			$(this).parents('form').find('.tt-email-recipient-project-partner-contact1').prop('checked', false);
			$(this).parents('form').find('.tt-email-recipient-project-partner-contact2').prop('checked', false);
			$(this).parents('form').find('.tt-email-recipient-active-participants').prop('checked', false);
			$(this).parents('form').find('.tt-email-recipient-user').val(null).trigger('change');
		}
	});

	// Bei Empfängerliste E-Mail andere Felder zurücksetzen wenn Projektpartner ausgewöhlt wurde
	$('body').on('change', '.tt-email-recipient-project-partner,.tt-email-recipient-project-partner-contact1,.tt-email-recipient-project-partner-contact2', function (e) {
		e.preventDefault();

		if ($(this)[0].checked) {
			$(this).parents('form').find('.tt-email-recipient-email').val('');
			if ($(this).hasClass('tt-email-recipient-project-partner-contact1')) {
				$(this).parents('form').find('.tt-email-recipient-project-partner').prop('checked', false);
				$(this).parents('form').find('.tt-email-recipient-project-partner-contact2').prop('checked', false);
			} else if ($(this).hasClass('tt-email-recipient-project-partner-contact2')) {
				$(this).parents('form').find('.tt-email-recipient-project-partner-contact1').prop('checked', false);
				$(this).parents('form').find('.tt-email-recipient-project-partner').prop('checked', false);
			} else {
				$(this).parents('form').find('.tt-email-recipient-project-partner-contact1').prop('checked', false);
				$(this).parents('form').find('.tt-email-recipient-project-partner-contact2').prop('checked', false);
			}
			$(this).parents('form').find('.tt-email-recipient-active-participants').prop('checked', false);
			$(this).parents('form').find('.tt-email-recipient-user').val(null).trigger('change');
		}
	});

	// Bei Empfängerliste E-Mail andere Felder zurücksetzen wenn alle aktiven Teilnehmer ausgewöhlt wurde
	$('body').on('change', '.tt-email-recipient-active-participants', function (e) {
		e.preventDefault();

		if ($(this)[0].checked) {
			$(this).parents('form').find('.tt-email-recipient-email').val('');
			$(this).parents('form').find('.tt-email-recipient-project-partner').prop('checked', false);
			$(this).parents('form').find('.tt-email-recipient-project-partner-contact1').prop('checked', false);
			$(this).parents('form').find('.tt-email-recipient-project-partner-contact2').prop('checked', false);
			$(this).parents('form').find('.tt-email-recipient-user').val(null).trigger('change');
		}
	});

	// Bei Empfängerliste E-Mail andere Felder zurücksetzen wenn Teilnehmer oder Benutzer ausgewöhlt wurde
	$('body').on('change', '.tt-email-recipient-user', function (e) {
		e.preventDefault();

		if ($(this).select2().val() !== '') {
			$(this).parents('form').find('.tt-email-recipient-email').val('');
			$(this).parents('form').find('.tt-email-recipient-project-partner').prop('checked', false);
			$(this).parents('form').find('.tt-email-recipient-project-partner-contact1').prop('checked', false);
			$(this).parents('form').find('.tt-email-recipient-project-partner-contact2').prop('checked', false);
			$(this).parents('form').find('.tt-email-recipient-active-participants').prop('checked', false);
		}
	});

	// Dokument auswählen (Open-Folder-Dialog anzeigen)
	$('body').on('click', '.tt-select-document', function (e) {
		e.preventDefault();

		$(this).parent().find('.tt-file-upload')[0].click();
	});

	// Dokument auswählen (Übernahme des Dateinamens in das Input-Feld)
	$('body').on('change', '.tt-file-upload', function (e) {
		$(this).parents('.form-group').find('.tt-file-name').val($(this)[0].files[0].name);
	});

	// Dokument anzeigen
	$('body').on('click', '.tt-show-document', function (e) {
		e.preventDefault();

		var listItem = $($(this).parents('.mt-element-list').find('.mt-list-container .mt-list-item.active')[0]);
		window.open(listItem.find('[name^="href_"]').val(), '_blank');
	});

	// E-Mail an Empfängerliste versenden
	$('body').on('click', '.tt-send-update-info-mail', function (e) {
		e.preventDefault();

		var element = $(this);

		App.blockUI({
			target: 'body',
			animate: true
		});

		ajax.ajaxCall($(this).attr('href') + '/' + $('#send_update_info').val(), $(this).attr('method'), null, false, function (data) {
			App.unblockUI('body');
			if (data === 'OK' || data === 'NO_EMAIL_RECIPIENT') {

				var messageText = Lang.get('extrax2-webadmin.send_update_info_mail_successfully');
				if (data === 'NO_EMAIL_RECIPIENT') {
					messageText = Lang.get('extrax2-webadmin.send_update_info_mail_no_recipients')
				}

				bootbox.dialog({
					message: messageText,
					title: Lang.get('extrax2-webadmin.send_update_info_mail'),
					buttons: {
						ok: {
							label: Lang.get('extrax2-webadmin.ok'),
							className: "btn blue",
							callback: function () {
							}
						}
					}
				});
			} else {
				swal({
						title: trans('extrax2-webadmin.error'),
						text: trans('extrax2-webadmin.send_update_info_mail_error'),
						type: 'error',
						allowOutsideClick: true,
						confirmButtonClass: 'btn-danger'
					},
					function (isConfirm) {
					});
			}
		});
	});

	// Anzahl angezeigte Zeilen ändern
	$('body').on('click', '.tt-number-of-rows', function (e) {

		var table = $('#' + $(this).data().tableId).DataTable();
		$(this).parent().find('button').removeClass('tt-selected').removeClass('active');
		$(this).addClass('tt-selected').addClass('active');
		if ($(this).data().value == 'all') {
			table.page.len(10000).draw();
		} else {
			table.page.len(parseInt($(this).data().value)).draw();
		}
	});

	// Produktivversion und BETA-Version schließen sich aus
	$('body').on('change', '[name="is_productive_version"],[name="is_beta_version"]', function (e) {
		e.preventDefault();

		if (this.name === 'is_productive_version' && $(this).is(':checked')) {
			$(this).parents('form').find('[name="is_beta_version"]').prop('checked', false);
		} else if (this.name === 'is_beta_version' && $(this).is(':checked')) {
			$(this).parents('form').find('[name="is_productive_version"]').prop('checked', false);
		}
	});

	// Hauptbehandler bei anderen gleichen Abrechnungs-ID abhaken
	$('body').on('change', '.tt-main-lanr-bsnr', function (e) {

		if ($(this).is(':checked')) {
			var accountIDElement = $(this).parents('.input-group').find('[name^="lanr_bsnr_account_id_"]')[0];
			$.each($(this).parents('.mt-list-container').find('[name^="lanr_bsnr_account_id_"]'), function (i, element) {
				if (element.id !== accountIDElement.id && $(element).val() == $(accountIDElement).val()) {
					$(element).parents('.input-group').find('[name^="main_lanr_bsnr_"]').removeAttr('checked');
				}
			});
		}
	});

	// Hauptbehandler bei anderen gleichen Abrechnungs-ID abhaken (bei Änderung Abrechnungs-ID)
	$('body').on('change', '[name^="lanr_bsnr_account_id_"],[name="lanr_bsnr_account_id"]', function (e) {

		var checkMain = $(this).parents('.input-group').find('[name^="main_lanr_bsnr_"],[name="main_lanr_bsnr"]');
		if ($(this).val() == '') {
			checkMain.removeAttr('checked');
			checkMain.attr('disabled', 'disabled');
		} else {
			checkMain.removeAttr('disabled');
		}
		if (checkMain.is(':checked')) {
			var accountIDElement = this;
			$.each($(this).parents('.mt-list-container').find('[name^="lanr_bsnr_account_id_"]'), function (i, element) {
				if (element.id !== accountIDElement.id && $(element).val() == $(accountIDElement).val()) {
					$(element).parents('.input-group').find('[name^="main_lanr_bsnr_"]').removeAttr('checked');
				}
			});
		}
	});

	// Pseudonymtyp - Mainzellisten URL en-disablen
	$('body').on('change', '[name="pseudonym_type"]', function (e) {
		e.preventDefault();

		if ($(this).select2().val() === '3') {
			$('.mainzelliste').removeClass('hide');
			$('.tripletrax').addClass('hide');
			$('.egk').addClass('hide');
			$('.pseudonym-hash').addClass('hide');
			$('[name="url_mainzelliste"]').removeAttr('disabled');
			$('[name="api_key_mainzelliste"]').removeAttr('disabled');
			$('[name="api_version_mainzelliste"]').removeAttr('disabled');
			$('[name="url_tripletrax"]').val('');
			$('[name="url_tripletrax"]').prop('disabled', 'disabled');
			$('[name="api_key_tripletrax"]').val('');
			$('[name="api_key_tripletrax"]').prop('disabled', 'disabled');
			$('[name="salt_pseudonym_hash"]').val('');
			$('[name="salt_pseudonym_hash"]').prop('disabled', 'disabled');
			$('[name="pseudonym_hash"]').removeAttr('checked');
			$('[name="pseudonym_hash"]').prop('disabled', 'disabled');
		} else if ($(this).select2().val() === '4' || $(this).select2().val() === '5') {
			$('.mainzelliste').addClass('hide');
			$('.tripletrax').removeClass('hide');
			$('.egk').addClass('hide');
			$('.pseudonym-hash').addClass('hide');
			$('[name="url_tripletrax"]').removeAttr('disabled');
			$('[name="api_key_tripletrax"]').removeAttr('disabled');
			$('[name="url_mainzelliste"]').val('');
			$('[name="url_mainzelliste"]').prop('disabled', 'disabled');
			$('[name="api_key_mainzelliste"]').val('');
			$('[name="api_key_mainzelliste"]').prop('disabled', 'disabled');
			$('[name="api_version_mainzelliste"]').val('');
			$('[name="api_version_mainzelliste"]').prop('disabled', 'disabled');
			$('[name="salt_pseudonym_hash"]').val('');
			$('[name="salt_pseudonym_hash"]').prop('disabled', 'disabled');
			$('[name="pseudonym_hash"]').removeAttr('checked');
			$('[name="pseudonym_hash"]').prop('disabled', 'disabled');
		} else if ($(this).select2().val() === '6') {
			$('.mainzelliste').addClass('hide');
			$('.tripletrax').addClass('hide');
			$('.egk').removeClass('hide');
			$('.pseudonym-hash').addClass('hide');
			$('[name="url_mainzelliste"]').val('');
			$('[name="url_mainzelliste"]').prop('disabled', 'disabled');
			$('[name="api_key_mainzelliste"]').val('');
			$('[name="api_key_mainzelliste"]').prop('disabled', 'disabled');
			$('[name="api_version_mainzelliste"]').val('');
			$('[name="api_version_mainzelliste"]').prop('disabled', 'disabled');
			$('[name="url_tripletrax"]').val('');
			$('[name="url_tripletrax"]').prop('disabled', 'disabled');
			$('[name="api_key_tripletrax"]').val('');
			$('[name="api_key_tripletrax"]').prop('disabled', 'disabled');
			$('[name="salt_pseudonym_hash"]').removeAttr('disabled');
			$('[name="pseudonym_hash"]').removeAttr('checked');
			$('[name="pseudonym_hash"]').prop('disabled', 'disabled');
		} else {
			$('.mainzelliste').addClass('hide');
			$('.tripletrax').addClass('hide');
			$('.egk').addClass('hide');
			$('[name="url_mainzelliste"]').val('');
			$('[name="url_mainzelliste"]').prop('disabled', 'disabled');
			$('[name="api_key_mainzelliste"]').val('');
			$('[name="api_key_mainzelliste"]').prop('disabled', 'disabled');
			$('[name="api_version_mainzelliste"]').val('');
			$('[name="api_version_mainzelliste"]').prop('disabled', 'disabled');
			$('[name="url_tripletrax"]').val('');
			$('[name="url_tripletrax"]').prop('disabled', 'disabled');
			$('[name="api_key_tripletrax"]').val('');
			$('[name="api_key_tripletrax"]').prop('disabled', 'disabled');
			$('[name="salt_pseudonym_hash"]').val('');
			$('[name="salt_pseudonym_hash"]').prop('disabled', 'disabled');
			if ($(this).select2().val() === '7') {
				$('[name="pseudonym_hash"]').removeAttr('checked');
				$('[name="pseudonym_hash"]').prop('disabled', 'disabled');
				$('.pseudonym-hash').addClass('hide');
			} else {
				$('[name="pseudonym_hash"]').removeAttr('disabled');
				$('.pseudonym-hash').removeClass('hide');
			}
		}
	});

	// Patientenlistenfilter - Patientenlisten URL en- disablen
	$('body').on('change', '[name="patientlist_filter_type"]', function (e) {
		e.preventDefault();

		if ($('[name="patientlist_filter_type"]:checked').val() === '') {
			$('[name="url_patientlist_filter"]').val('');
			$('[name="url_patientlist_filter"]').prop('disabled', 'disabled');
		} else {
			$('[name="url_patientlist_filter"]').removeAttr('disabled');
		}
	});


	// Patientenlistenfilter - Patientenlisten URL en- disablen
	$('body').on('change', '[name="patientlist_only_patients_with_accounting_items"]', function (e) {
		e.preventDefault();

		if ($(this).is(':checked')) {
			$('[name="accounting_items_period"]').removeAttr('disabled');
			$('[name="accounting_items_period_time_unit"]').removeAttr('disabled');
		} else {
			$('[name="accounting_items_period"]').val('');
			$('[name="accounting_items_period"]').prop('disabled', 'disabled');
			$('[name="accounting_items_period_time_unit"]').select2().val('').trigger('change');
			$('[name="accounting_items_period_time_unit"]').prop('disabled', 'disabled');
		}
	});

	// Beim Exportformat TTI kann Exportdatei nicht aufgesplittet werden.
	$('body').on('change', '[name="export_format"]', function (e) {
		e.preventDefault();

		if ($(this).select2().val() === 'TTI') {
			$('[name="split_export_file"]').select2().val('No').trigger('change');
			$('[name="split_export_file"]').prop('disabled', 'disabled');
		} else {
			$('[name="split_export_file"]').removeAttr('disabled');
		}
	});

	$('body').on('change', '[name="split_export_file"]', function (e) {
		e.preventDefault();

		if ($(this).select2().val() === 'Chunk') {
			$('.chunk').removeClass('hide');
			$('[name="export_chunk_size"]').removeAttr('disabled');
			$('[name="initial_export_chunk_size"]').removeAttr('disabled');
		} else {
			$('.chunk').addClass('hide');
			$('[name="export_chunk_size"]').val('');
			$('[name="export_chunk_size"]').prop('disabled', 'disabled');
			$('[name="initial_export_chunk_size"]').val('');
			$('[name="initial_export_chunk_size"]').prop('disabled', 'disabled');
		}
	});

	// Seriennummern in Zwischenablage kopieren
	$('body').on('change', '[name="serial_number"]', function (e) {
		e.preventDefault();

		var values = $(this).select2('val');
		if (utils.isUndefined(values) || values === '') {
			$(this).parents('.input-group').find('.tt-copy-values').attr('disabled', 'disabled');
		} else {
			$(this).parents('.input-group').find('.tt-copy-values').removeAttr('disabled');
			$(this).parents('.input-group').find('.tt-copy-values').attr('data-clipboard-text', values.join(' '));
		}
	});

	// Nur Teilnehmer anzeigen, die BETA-Tester sind
	$('body').on('click', '[name="show_beta_tester"]', function (e) {
		if ($(this).is(':checked')) {
			$(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail,.tt-datatable-data').DataTable().column(8).search(1, true, true).draw();
		}
		else {
			$(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail,.tt-datatable-data').DataTable().column(8).search('', true, true).draw();
		}
	});

	// Beim Exportformat TTI kann Exportdatei nicht aufgesplittet werden.
	$('body').on('select2:select', '.tt-attribute-key', function (e) {
		e.preventDefault();

		if (!utils.isUndefined(e.params.data) && !utils.isUndefined($(e.params.data.element).data()) && !utils.isUndefined($(e.params.data.element).data().values) && $(e.params.data.element).data().values !== '') {

			let element = $('.tt-attribute-select');
			$(element).find('tt-select2').select2('destroy');
			element.empty();
			element.append('<select style="width:100%" id="m_select" name="select" class="form-control tt-select2" tabindex="123" data-select2-placeholder="value"><option></option></select>');

			let data = [];
			let array = $(e.params.data.element).data().values.split("|");
			jQuery.each(array, function (i, val) {
				data.push({id: val, text:val});
			});
			element.find('select').select2({
				placeholder: Lang.get('extrax2-webadmin.value'),
				allowClear: true,
				data: data,
				multiple: false
			});

			element.removeClass('hide');
			$('.tt-attribute-value').addClass('hide');
		} else {
			$('.tt-attribute-select').addClass('hide');
			$('.tt-attribute-value').removeClass('hide');
		}
	});
}

function checkForExistingData(element, table, id, aPos) {

	return $.Deferred(function (defer) {
		if (table[0].id === "table_users") {
			// Benutzer darf nur gelöscht werden, wenn er noch keine Daten dokumentiert hat
			ajax.ajaxCallDeferred("admin/users/checkdata/" + $('#content-detail').find('.tt-selected-id').val(), "GET", $('#content-detail').find('.tt-selected-id').val(), false).done(function (data) {

				if (ajax.ajaxSucceeded(data)) {
					if (data === 'existing') {

						bootbox.dialog({
							message: Lang.get('extrax2-webadmin.delete_user_not_possible_desc'),
							title: Lang.get('extrax2-webadmin.delete_user', {'username': '<span class="font-red-intense">\'' + $("#username").val() + '\'</span>'}),
							buttons: {
								ok: {
									label: Lang.get('extrax2-webadmin.ok'),
									className: "btn blue",
									callback: function () {
									}
								}
							}
						});

						defer.resolve(true);
					} else {
						defer.resolve(false);
					}
				} else {
					defer.reject();
				}
			});
		} else if (table[0].id === "table_projects") {
			// Projekt darf nur gelöscht werden, wenn noch keine Daten dafür existieren
			ajax.ajaxCallDeferred("admin/projects/checkdata/" + $('#content-detail').find('.tt-selected-id').val(), "GET", $('#content-detail').find('.tt-selected-id').val(), false).done(function (data) {

				if (ajax.ajaxSucceeded(data)) {
					if (data === 'existing') {

						bootbox.dialog({
							message: Lang.get('extrax2-webadmin.delete_project_not_possible_desc'),
							title: Lang.get('extrax2-webadmin.delete_project', {'projectname': '<span class="font-red-intense">\'' + $("#projectname").val() + '\'</span>'}),
							buttons: {
								ok: {
									label: Lang.get('extrax2-webadmin.ok'),
									className: "btn blue",
									callback: function () {
									}
								}
							}
						});

						defer.resolve(true);
					} else {
						defer.resolve(false);
					}
				} else {
					defer.reject();
				}
			});
		} else if (table[0].id === "table_participants") {
			// Projekt darf nur gelöscht werden, wenn noch keine Daten dafür existieren
			ajax.ajaxCallDeferred("admin/participants/checkdata/" + $('#content-detail').find('.tt-selected-id').val(), "GET", $('#content-detail').find('.tt-selected-id').val(), false).done(function (data) {

				if (ajax.ajaxSucceeded(data)) {
					if (data === 'existing') {

						bootbox.dialog({
							message: Lang.get('extrax2-webadmin.delete_participant_not_possible_desc'),
							title: Lang.get('extrax2-webadmin.delete_participant', {'participant': '<span class="font-red-intense">\'' + $("#medical_practice_name").val() + '\'</span>'}),
							buttons: {
								ok: {
									label: Lang.get('extrax2-webadmin.ok'),
									className: "btn blue",
									callback: function () {
									}
								}
							}
						});

						defer.resolve(true);
					} else {
						defer.resolve(false);
					}
				} else {
					defer.reject();
				}
			});
		} else if (table[0].id === "table_commission_recipients") {
			// Projekt darf nur gelöscht werden, wenn noch keine Daten dafür existieren
			ajax.ajaxCallDeferred("admin/commission_recipients/checkdata/" + $('#content-detail').find('.tt-selected-id').val(), "GET", $('#content-detail').find('.tt-selected-id').val(), false).done(function (data) {

				if (ajax.ajaxSucceeded(data)) {
					if (data === 'existing') {

						bootbox.dialog({
							message: Lang.get('extrax2-webadmin.delete_commission_recipient_not_possible_desc'),
							title: Lang.get('extrax2-webadmin.delete_commission_recipient', {'commission_recipient': '<span class="font-red-intense">\'' + $("#address1").val() + ' ' + $("#address2").val() + '\'</span>'}),
							buttons: {
								ok: {
									label: Lang.get('extrax2-webadmin.ok'),
									className: "btn blue",
									callback: function () {
									}
								}
							}
						});

						defer.resolve(true);
					} else {
						defer.resolve(false);
					}
				} else {
					defer.reject();
				}
			});
		} else if (table[0].id === "table_software_versions") {
			// Projekt darf nur gelöscht werden, wenn noch keine Daten dafür existieren
			ajax.ajaxCallDeferred("admin/software_versions/checkdata/" + $('#content-detail').find('.tt-selected-id').val(), "GET", $('#content-detail').find('.tt-selected-id').val(), false).done(function (data) {

				if (ajax.ajaxSucceeded(data)) {
					if (data === 'existing') {

						bootbox.dialog({
							message: Lang.get('extrax2-webadmin.delete_software_version_not_possible_desc'),
							title: Lang.get('extrax2-webadmin.delete_software_version', {'version': '<span class="font-red-intense">\'' + $("#version").val() + '\'</span>'}),
							buttons: {
								ok: {
									label: Lang.get('extrax2-webadmin.ok'),
									className: "btn blue",
									callback: function () {
									}
								}
							}
						});

						defer.resolve(true);
					} else {
						defer.resolve(false);
					}
				} else {
					defer.reject();
				}
			});
		} else {
			defer.resolve(false, '');
		}
	}).promise();
}

function checkForExistingListData(table, id) {

	return $.Deferred(function (defer) {
		if (table[0].id === "table_participant_lanr_bsnr" && !utils.isUndefined($('.tt-selected-id').val())) {
			// BSNR/LANR darf nur gelöscht werden, wenn noch nichts abgerechnet wurde und keine Daten dafür hochgeladen wurden
			ajax.ajaxCallDeferred('admin/participants/checkdata/' + $('.tt-selected-id').val() + '/bsnr_lanr/' + id, 'GET', $('#content-detail').find('.tt-selected-id').val(), false).done(function (data) {

				if (ajax.ajaxSucceeded(data)) {
					if (data === 'existing') {

						var activeListItem = $(table).find('.mt-list-container .mt-list-item.active');
						bootbox.dialog({
							message: Lang.get('extrax2-webadmin.delete_bsnr_lanr_not_possible_desc'),
							title: Lang.get('extrax2-webadmin.delete_bsnr_lanr', {'bsnr_lanr': '<span class="font-red-intense">' + $(activeListItem).find('[name^="bsnr_"]').val() + ' / ' + $(activeListItem).find('[name^="lanr_"]').val() + '</span>'}),
							buttons: {
								ok: {
									label: Lang.get('extrax2-webadmin.ok'),
									className: "btn blue",
									callback: function () {
									}
								}
							}
						});

						defer.resolve(true);
					} else {
						defer.resolve(false);
					}
				} else {
					defer.reject();
				}
			});
		} else {
			defer.resolve(false);
		}
	}).promise();
}

function drawUpAccount(element, tableData) {
	var tillVal = jQuery($('#till_date')).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '');
	if (tillVal !== '') {
		var picker = $('#till_date').data('picker');
		tillVal = utils.dateToString(picker.getDate());
	}

	ajax.ajaxCall(element.attr('action'), element.attr('method'), 'till_date=' + tillVal + '&table_data=' + encodeURIComponent(JSON.stringify(tableData)), false, function (data) {

		utils.setHtmlData($("#content"), data, true);
		exportAccountDataToExcel(element.attr('action') + '/export_to_xslx', tableData);
	});
}

function exportAccountDataToExcel(url, tableData) {

	var xhr = new XMLHttpRequest();
	xhr.open('POST', url, true);

	xhr.responseType = 'blob';
	xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));

	xhr.onload = function(e) {
		if (this.status == 200) {
			const blob = new Blob([this.response], {type: this.getResponseHeader('Content-Type')});
			const url = window.URL.createObjectURL(blob);
			const contentDisposition = this.getResponseHeader('content-disposition');
			let fileName = 'unknown';
			if (contentDisposition) {
				// filename*=UTF-8''... bzw. filename="..." oder filename=... (ohne Anführungszeichen)
				const fileNameStarMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
				const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
				if (fileNameStarMatch)
					fileName = decodeURIComponent(fileNameStarMatch[1]);
				else if (fileNameMatch)
					fileName = fileNameMatch[1];
			}
			if (window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob, fileName);
			} else {
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', fileName);
				document.body.appendChild(link);
				link.click();
				setTimeout(() => {
					link.remove();
					window.URL.revokeObjectURL(url);
				}, 3000);
			}
		}
	};

	let formData = new FormData();
	formData.append('table_data', JSON.stringify(tableData));
	xhr.send(formData);
}

module.exports.registerCommonEvents = registerCommonEvents;
